<template>
    <div v-if="bigWheelActivityType !== '4'"
        v-cloak
        class="awardRotate"
        :style="{background: bgColor}">
        <login-in v-if="loginType==='wechat'"
            :isLoginFlag="isLoginFlag"
            :activityTypeFlag="activityTypeFlag"
            :activityUrl="activityUrl"></login-in>
        <!-- 业务不需要返回小程序页面按钮，暂时隐藏  -->
        <!-- <div v-show="miniprogramFlag && isShowBackBtn && activityObj.miniType == 1" class="xcx-back-btn"
            @click="goHiHonorMiniProgram('my')">
            <img src="static/runtime/images/magic/award/xcxBack.png"
                alt=""
                style="width: 100%;">
        </div> -->
        <!--轮盘锦鲤，中奖信息展示，待优化为组件-->
        <div v-if="activityObj.prizeWinningScrollFlag == 0 && activityObj.prizeWinningStyleLocation == 0 && tigerWinningList.length && tigerLottery"
            class="award-list"
            :style="{'background-color': activityObj.scrollBackgroudColor || '#FFFFFF',
      'color': activityObj.scrollWordsColor || '#333',
      'max-height': 60 * (activityObj.prizeWinningNumbers || 3) + 'px',}">
            <div id="scrollBox"
                style="position: relative;">
                <div v-for="item in tigerWinningList"
                    :key="item.creationDate"
                    class="award-list-item">
                    <!--用户信息（头像、昵称）-->
                    <div class="award-list-item-options">
                        <img v-if="item.userHeadPortraitUrl"
                            :src="item.userHeadPortraitUrl">
                        <img v-else
                            src="static/runtime/images/magic/award/userImg.png">
                        <div class="ellipsis">{{ item.nickName }}</div>
                    </div>
                    <!--奖品名称-->
                    <div class="award-list-item-options ellipsis">
                        <div v-if="item.rewardType == '4'">{{ item.pointValue }}积分</div>
                        <div v-else>{{ item.rewardName }}</div>
                    </div>
                    <!--中奖时间-->
                    <div class="award-list-item-options ellipsis">{{ item.creationDateStr }}</div>
                </div>
            </div>
        </div>
        <!--轮盘锦鲤，第一节，顶部背景图片-->
        <div class="section-one">
            <img :src="bannerPic"
                alt=""
                style="width: 100%;"></img>
        </div>
        <!--轮盘锦鲤，第二节，中间抽奖区域-->
        <div v-if="tigerLottery"
            class="section-two"
            :style="{'background': tigerBgColor}">
            <!--老虎机-->
            <div>
                <tigerMachineLottery ref="tigerMachineDraw"
                    :tips="tips"
                    :activityInfo="activityObj"
                    :awardPool="bigWheelRewardList"
                    :drawChances="Number(participateTimes)"
                    :pointDrawFlag="pointDrawFlag"
                    :activityStatus="Number(activityStatus)"
                    :userBase="userBase"
                    :communityUserStatus="communityUserStatus"
                    :drawType="drawType"
                    @startTigerMachine="pointer"
                    @endTigerMachine="tigerMachineWinningHandler"></tigerMachineLottery>
            </div>
            <!--登录按钮，跳转小程序-->
            <div v-if="pointDrawFlag && loginType == 'Alipay'"
                class="member-login-area">
                <div class="member-login-text"
                    :style="{'font-size': '15px', 'background-image': 'linear-gradient(0deg,' + bgColor + ',' + bgColor + ')'}">登录荣耀会员获得抽奖机会</div>
                <!-- 在小程序内打开H5 -->
                <div class="member-login-btn"
                    @click="goHiHonorMiniProgram('index')"></div>
            </div>
        </div>
        <!--微信hihonor小程序内且是启用分享且是分享抽奖且是进行中大转盘活动才显示-->
        <div v-if="miniprogramFlag && activityObj.miniType === '1' && activityObj.shareFlag === '1' && activityObj.activityStatus === '1' && activityObj.extendConfig.participateType && activityObj.extendConfig.participateType.indexOf('6') >= 0"
            id="signCorner"
            class="share-btn-area"
            @click="openGuide()">
            <div class="share-title">
                活动分享
            </div>
            <div class="share-desc">
                剩余分享{{ remainingSharingTimes }}次
            </div>
        </div>
        <!--大转盘和盲盒，轮盘锦鲤我的奖品和中奖名单-->
        <div class="banner awardRotateDisc">
            <!-- 抽奖名单展示（转盘上方） activityObj.prizeWinningStyleLocation == 0 -->
            <div v-if="activityObj.prizeWinningScrollFlag == 0 && activityObj.prizeWinningStyleLocation == 0 && winnerList.length && !tigerLottery"
                class="award-list"
                :style="{'background-color': activityObj.scrollBackgroudColor || '#FFFFFF',
        'color': activityObj.scrollWordsColor || '#333', 'border-radius': '10px',
        'max-height': 60 * (activityObj.prizeWinningNumbers || 3) + 'px',
        width: '96.2%', 'margin': '20px auto'}">
                <div id="scrollBox"
                    style="position: relative;">
                    <div v-for="item in winnerList"
                        :key="item.creationDate"
                        class="award-list-item">
                        <div class="award-list-item-options">
                            <img v-if="item.userHeadPortraitUrl"
                                :src="item.userHeadPortraitUrl">
                            <img v-else
                                src="static/runtime/images/magic/award/userImg.png">
                            <div class="ellipsis">{{ item.nickName }}</div>
                        </div>
                        <div class="award-list-item-options ellipsis">
                            <div v-if="item.rewardType == '4'">{{ item.pointValue }}积分</div>
                            <div v-else>{{ item.rewardName }}</div>
                        </div>
                        <div class="award-list-item-options ellipsis">{{ item.creationDateStr }}</div>
                    </div>
                </div>
            </div>
            <!-- 大转盘抽奖区域 -->
            <div v-if="bigWheelActivityType == '1'"
                id="turnplate"
                ref="turnplate"
                class="turnplate">
                <!-- 背景 -->
                <img :src="drawWheelUrl"
                    alt=""
                    style="width: 100%;">
                <canvas id="wheelcanvas"
                    ref="wheelcanvas"
                    class="item"
                    width="1688"
                    height="1688"
                    style="position: absolute; left: 0; top: 0;"></canvas>
                <!-- 抽奖指针按钮 -->
                <div v-if="!pointDrawFlag && activityStatus == 1 && canDrawFlag"
                    class="pointer"
                    @click="pointer()">
                    <img :src="drawPointUrl"
                        alt="">
                    <div class="text-wrap">
                        <p style="font-size: 40px;">GO</p>
                        <div style="margin-top: -8px; font-size: 16px;">
                            <!-- 非积分抽奖 -->
                            <p v-if="drawType == 'initDraw' || drawType == 'orderDraw'||drawType == 'otherDraw'">还有{{ participateTimes
              > 99 ? '99+' : participateTimes }}次</p>
                            <!-- 积分抽奖 -->
                            <p v-if="drawType == 'pointDraw'">{{ drawPointConsumption }}{{ poinsOrDiamonds }}/次</p>
                        </div>
                    </div>
                </div>

                <!-- 不是会员，需要入会的情况 -->
                <div v-if="pointDrawFlag"
                    class="member-login">
                    <img src="static/runtime/images/magic/award/zp_zz_hs.png"
                        alt="">
                    <div class="text-wrap">
                        <p style="font-size: 40px;">GO</p>
                        <div style="margin-top: -8px; font-size: 16px;">
                            <p v-if="drawType == 'initDraw' || drawType == 'orderDraw'||drawType == 'otherDraw'">
                                还有{{ participateTimes > 99 ? '99+' : participateTimes }}次</p>
                            <p v-if="drawType == 'pointDraw'">{{ drawPointConsumption }}{{ poinsOrDiamonds }}/次</p>
                        </div>
                    </div>
                    <!-- 跳转小程序 -->
                    <!-- 小程序内打开H5时 -->
                    <div v-if="miniprogramFlag || loginType == 'Alipay'"
                        class="member-login-btn"
                        @click="goHiHonorMiniProgram('index')"></div>
                    <!-- 微信打开H5时跳转 -->
                    <div v-if="!miniprogramFlag && loginType == 'wechat'"
                        class="member-login-btn">
                        <div v-if="miniType === '1'"
                            class="wxOpenLaunchWeapp">
                            <wx-open-launch-weapp id="launch-btn"
                                :username="hiHonorWxAppId"
                                :env-version="envVersion"
                                :path="`pages/tabBar/index/index.html?activityUrl=${encodeURIComponent(activityUrl)}`">
                                <script type="text/wxtag-template">
                                    <div style="width: 1000px; height: 500px; display: block; opacity: 0; color: red; background: green;">打开小程序</div>
                </script>
                            </wx-open-launch-weapp>
                        </div>
                        <div v-if="miniType === '2'"
                            class="wxOpenLaunchWeapp">
                            <wx-open-launch-weapp id="launch-btn"
                                username="gh_c31414cf312a"
                                :env-version="envVersion"
                                :path="`pages/index?activityUrl=${encodeURIComponent(activityUrl)}`">
                                <script type="text/wxtag-template">
                                    <div style="width: 1000px; height: 500px; display: block; opacity: 0; color: red; background: green;">打开小程序</div>
                </script>
                            </wx-open-launch-weapp>
                        </div>
                    </div>
                </div>
                <!-- 大转盘，没有抽奖机会，判断逻辑待优化 -->
                <div v-if="!pointDrawFlag && activityStatus == 1 && (drawType == 'initDraw' || drawType == 'orderDraw' || !drawType) && !canDrawFlag"
                    class="pointer disable"
                    @click="noChance">
                    <img src="static/runtime/images/magic/award/zp_zz_hs.png"
                        alt="">
                    <div class="text-wrap"
                        style="top: 60%; color: #4A66FF; font-size: 18px;">
                        <p v-if="tips"
                            style="padding:20px">{{ tips }}</p>
                        <p v-else>还剩<span class="count">0</span>次</p>
                    </div>
                </div>
                <!-- 大转盘，积分抽奖场景，积分不足 -->
                <div v-if="!pointDrawFlag && activityStatus == 1 && drawType == 'pointDraw' && !canDrawFlag"
                    class="pointer"
                    @click="noPoints">
                    <img :src="drawPointUrl"
                        alt="">
                    <div class="text-wrap">
                        <p style="font-size: 40px;">GO</p>
                        <div style="margin-top: -8px; font-size: 16px;">
                            <p>{{ drawPointConsumption }}{{ poinsOrDiamonds }}/次</p>
                        </div>
                    </div>
                </div>
                <!-- 活动未开始，活动已结束，活动已暂停，逻辑待优化 -->
                <div v-if="activityStatus == 0"
                    class="pointer disable"
                    @click="notStart">
                    <img src="static/runtime/images/magic/award/zp_zz_hs.png"
                        alt="">
                    <div class="text-wrap"
                        style="top: 60%; color: #4A66FF; font-size: 18px;">
                        <p>活动未开始</p>
                    </div>
                </div>
                <div v-if="activityStatus == 3"
                    class="pointer disable"
                    @click="hasEnd">
                    <img src="static/runtime/images/magic/award/zp_zz_hs.png"
                        alt="">
                    <div class="text-wrap"
                        style="top: 60%; color: #4A66FF; font-size: 18px;">
                        <p>活动已结束</p>
                    </div>
                </div>
                <div v-if="activityStatus == 2"
                    class="pointer disable"
                    @click="hasStop">
                    <img src="static/runtime/images/magic/award/zp_zz_hs.png"
                        alt="">
                    <div class="text-wrap"
                        style="top: 60%; color: #4A66FF; font-size: 18px;">
                        <p>活动已暂停</p>
                    </div>
                </div>
            </div>

            <!-- 盲盒抽奖区域 -->
            <div v-if="bigWheelActivityType == '2'"
                class="blindBox-main">
                <!-- 抽奖引导图 -->
                <img v-if="(activityStatus == '0' || activityStatus == '1') && participateTimes && guideLotteryUrl && !whetherActivity"
                    class="guideLotteryUrl"
                    :src="guideLotteryUrl"
                    alt="" />
                <img v-if="(activityStatus == '0' || activityStatus == '1') && participateTimes && !guideLotteryUrl && !whetherActivity"
                    class="guideLotteryUrl"
                    src="static/runtime/images/magic/award/guideLottery.png"
                    alt="" />
                <!-- 定时开奖样式 -->
                <div v-if="regularDrawShowStatus && ['1','2','3','6'].includes(regularDrawShowStatus)"
                    class="before-award-mask">
                    <div v-if="regularDrawShowStatus == '1'"
                        class="award-mask-center">
                        <div>
                            恭喜您已中奖
                        </div>
                    </div>
                    <div v-if="regularDrawShowStatus == '2'"
                        class="award-mask-center">很遗憾未中奖</div>
                    <div v-if="regularDrawShowStatus == '3'"
                        class="award-mask-center">活动已结束</div>
                    <div v-if="regularDrawShowStatus == '6'"
                        class="award-mask-center">
                        <p style="margin: 30px 0px -25px 0;">开奖中···</p>
                        <p style="margin-top: 20px;">请耐心等待 </p>
                    </div>
                </div>
                <!-- 盲盒抽奖 （定时抽奖只有初始化可抽奖）活动进行中，用户无次数 -->
                <div v-if="regularDrawShowStatus && regularDrawShowStatus == '4' && drawWheelType == '3' && participateType == '1'"
                    class="before-award-mask">
                    <div class="award-mask-center">
                        <p>待开奖</p>
                        <p class="font-24">{{ '已超过' + userNum + '位参加' }} </p>
                        <div v-for="(item,index) in headerList"
                            :key="index"
                            style="display: inline;">
                            <img v-if="item"
                                :src="item"
                                style="width: 16%; height: 16%; margin-right: 2px;" />
                            <img v-else
                                src="static/runtime/images/magic/award/userImg.png"
                                style="width: 16%; height: 16%; margin-right: 2px;"
                                alt="" />
                        </div>
                        <p v-if="userNum > 5"
                            style="display: inline;">...</p>
                    </div>
                </div>
                <!-- 盲盒抽奖 （定时抽奖 除只配置 初始化可抽奖 的其他可能 抽奖按钮都展示 --刘赟/侯宁）活动进行中 -->
                <div v-if="hasMask && drawWheelType == '3' && participateType != '1'"
                    class="before-award-mask">
                    <div class="award-mask-center">
                        <p v-if="winningRate > 0">中奖率+{{ winningRate }}</p>
                        <p class="font-20">待开奖</p>
                        <p class="font-20">{{ '已超过' + userNum + '位参加' }} </p>
                        <div v-for="(item,index) in headerList"
                            :key="index"
                            style="display: inline;">
                            <img v-if="item"
                                :src="item"
                                style="width: 16%; height: 16%; margin-right: 2px;" />
                            <img v-else
                                src="static/runtime/images/magic/award/userImg.png"
                                style="width: 16%; height: 16%; margin-right: 2px;"
                                alt="" />
                        </div>
                        <p v-if="userNum > 5"
                            style="display: inline;">...</p>
                        <div><Button class="lottery-btn"
                                @click="goLottery()"><span>抽奖</span></Button></div>
                    </div>
                </div>
                <!-- 背景 -->
                <img v-if="drawWheelUrl"
                    :src="drawWheelUrl"
                    alt=""
                    style="width: 100%;" />
                <!-- 盲盒礼物 -->
                <div v-if="drawPointUrl"
                    class="blindBox-box">
                    <img v-for="item in 6"
                        :key="item"
                        :src="drawPointUrl"
                        :class="{'blindBox-anima': boxIndex == item}"
                        @click="pointer(item)" />
                </div>
                <!-- 需要入会，跳转小程序入会 -->
                <div v-if="pointDrawFlag"
                    class="blindBox-mask">
                    <div v-if="miniprogramFlag || loginType == 'Alipay'"
                        class="member-login-btn"
                        @click="goHiHonorMiniProgram('index')"></div>
                    <div v-if="!miniprogramFlag && loginType == 'wechat'"
                        class="member-login-btn">
                        <div v-if="miniType === '1'"
                            class="wxOpenLaunchWeapp">
                            <wx-open-launch-weapp id="launch-btn"
                                :username="hiHonorWxAppId"
                                :env-version="envVersion"
                                :path="`pages/tabBar/index/index.html?activityUrl=${encodeURIComponent(activityUrl)}`">
                                <script type="text/wxtag-template">
                                    <div style="width: 1000px; height: 500px; display: block; opacity: 0; color: red; background: green;">打开小程序</div>
              </script>
                            </wx-open-launch-weapp>
                        </div>
                        <div v-if="miniType === '2'"
                            class="wxOpenLaunchWeapp">
                            <wx-open-launch-weapp id="launch-btn"
                                username="gh_c31414cf312a"
                                :env-version="envVersion"
                                :path="`pages/index?activityUrl=${encodeURIComponent(activityUrl)}`">
                                <script type="text/wxtag-template">
                                    <div style="width: 1000px; height: 500px; display: block; opacity: 0; color: red; background: green;">打开小程序</div>
                </script>
                            </wx-open-launch-weapp>
                        </div>
                    </div>
                </div>
                <!-- 没有次数时覆盖盒子 -->
                <div v-if="!pointDrawFlag && activityStatus == 1 && (drawType == 'initDraw' || drawType == 'orderDraw' || !drawType) && !canDrawFlag"
                    class="blindBox-mask"
                    @click="noChance">
                </div>
                <!-- 积分抽奖没有积分时覆盖盒子 -->
                <div v-if="activityStatus == 1 && drawType == 'pointDraw' && !canDrawFlag"
                    class="blindBox-mask"
                    @click="noPoints">
                </div>
                <!-- 活动未开始时覆盖盲盒 -->
                <div v-if="activityStatus == 0"
                    class="blindBox-mask"
                    @click="notStart"></div>
                <!-- 活动已结束覆盖盲盒 -->
                <div v-if="activityStatus == 3"
                    class="blindBox-mask"
                    @click="hasEnd"></div>
                <!-- 活动已暂停覆盖盲盒 -->
                <div v-if="activityStatus == 2"
                    class="blindBox-mask"
                    @click="hasStop"></div>
            </div>

            <!-- 抽奖名单展示（转盘下方）activityObj.prizeWinningStyleLocation == 1 -->
            <div v-if="activityObj.prizeWinningScrollFlag == 0 && activityObj.prizeWinningStyleLocation == 1 && winnerList.length"
                class="award-list"
                :style="{'background-color': activityObj.scrollBackgroudColor || '#FFFFFF',
        'color': activityObj.scrollWordsColor || '#333', 'border-radius': '10px',
        'max-height': 60 * (activityObj.prizeWinningNumbers || 3) + 'px',
        width: '96.2%', 'margin': '20px auto'}">
                <div id="scrollBox"
                    style="position: relative;">
                    <div v-for="item in winnerList"
                        :key="item.creationDate"
                        class="award-list-item">
                        <div class="award-list-item-options">
                            <img v-if="item.userHeadPortraitUrl"
                                :src="item.userHeadPortraitUrl">
                            <img v-else
                                src="static/runtime/images/magic/award/userImg.png">
                            <div class="ellipsis">{{ item.nickName }}</div>
                        </div>
                        <div class="award-list-item-options ellipsis">
                            <div v-if="item.rewardType == '4'">{{ item.pointValue }}积分</div>
                            <div v-else>{{ item.rewardName }}</div>
                        </div>
                        <div class="award-list-item-options ellipsis">{{ item.creationDateStr }}</div>
                    </div>
                </div>
            </div>
            <!--大转盘支持积分抽奖-->
            <div v-if="pointDrawFlag && !tigerLottery && loginType == 'Alipay'"
                class="member-tips-login">
                <div class="member-tips-login-text"
                    :style="{'font-size': '15px', 'background-image': 'linear-gradient(0deg,' + bgColor + ',' + bgColor + ')'}">登录荣耀会员获得抽奖机会</div>
                <div class="member-login-btn"
                    @click="goHiHonorMiniProgram('index')"></div>
            </div>

            <!-- 盲盒显示剩余次数 -->
            <div v-if="activityStatus == 2 && !tigerLottery"
                class="blindBox-chance">活动已暂停</div>
            <!-- 普通抽奖 盲盒剩余次数展示逻辑 -->
            <div v-else-if="!pointDrawFlag && bigWheelActivityType == '2' && (drawWheelType == '1' || drawWheelType == '2')"
                class="blindBox-chance">
                <div v-if="drawType == 'initDraw' || drawType == 'orderDraw'||drawType == 'otherDraw'">
                    <div v-if="tips">{{ tips }}</div>
                    <div v-else> 剩余抽奖次数：{{ participateTimes > 99 ? '99+' : participateTimes }}次</div>
                </div>
                <div v-if="drawType == 'pointDraw'">每次抽奖扣除{{ drawPointConsumption }}{{ poinsOrDiamonds }}</div>
            </div>
            <!-- 定时抽奖 盲盒剩余次数展示逻辑 -->
            <div v-else-if="!pointDrawFlag && bigWheelActivityType == '2' && drawWheelType == '3'"
                class="blindBox-chance">
                <div v-if="(drawType == 'initDraw' || drawType == 'orderDraw'||drawType == 'otherDraw') && ['4','5'].includes(regularDrawShowStatus)">
                    <div v-if="tips">{{ tips }}</div>
                    <div v-else> 剩余抽奖次数：{{ participateTimes > 99 ? '99+' : participateTimes }}次</div>
                </div>
            </div>

            <!-- 公共按钮区 -->
            <div :class="tigerLottery ? 'tiger-btn-area': ''">
                <div class="myAwardBtn"
                    :style=getButtonBgStyle>
                    我的奖品
                    <!-- 体验店小程序内场景，包括微信和支付宝小程序 -->
                    <div v-if="(miniprogramFlag && activityObj.miniType === '1') || loginType == 'Alipay'"
                        @click="goHiHonorMiniProgram('rewardQuery')"></div>
                    <!-- 直营店小程序内场景，只微信小程序 -->
                    <div v-if="(miniprogramFlag && activityObj.miniType === '2')"
                        @click="goBrandStoreMiniProgram('rewardQuery')"></div>
                    <!-- 不在小程序内场景 -->
                    <div v-if="!miniprogramFlag && loginType == 'wechat'">
                        <!-- 体验店 -->
                        <div v-if="(activityObj.miniType === '1')"
                            class="wxOpenLaunchWeapp"
                            v-html="wxOpenLaunchWeappHiHonor"></div>
                        <!-- 直营店 -->
                        <div v-if="(activityObj.miniType === '2')"
                            class="wxOpenLaunchWeapp"
                            v-html="wxOpenLaunchWeappBrandStore"></div>
                    </div>
                </div>
                <div class="winnerBtn"
                    :style=getButtonBgStyle
                    @click="goWinnerList">
                    中奖名单 &gt;
                </div>
            </div>
        </div>

        <div style="clear:both"></div>

        <!--轮盘锦鲤，第三节，底部信息展示区域-->
        <div :style="{'background': sectionThreeColor}"
            class="section-three">

            <!-- 奖品池展示（共用） -->
            <div v-if="bigWheelActivityType == '2' || tigerLottery"
                class="blindBox-info">
                <div :style="{'color': sectionThreeColor}"
                    :class="tigerLottery ? 'tiger-prizes-title' : 'blindBox-prizes-title' "
                    class="blindBox-info-title">
                    <div>奖品池</div>
                </div>
                <!-- 活动为轮盘锦鲤且奖品数量不超过4个，或活动非轮盘锦鲤 -->
                <div v-if="tigerLottery && awardNum <= 4 || !tigerLottery"
                    id="awardsPool"
                    class="blindBox-info-reward"
                    :class="{'blindBox-info-reward-center': awardNum < 5}">
                    <div v-for="item in bigWheelRewardList"
                        v-show="item.goodsType != '0'"
                        :key="item.id"
                        class="blindBox-info-reward-box">
                        <img :src="item.imgUrl">
                        <div class="ellipsis ellipsis-two">{{ item.goodsName }}</div>
                    </div>
                </div>
                <!--水平滚动展示奖品池（轮盘锦鲤特有）-->
                <vueSeamlessScroll v-if="tigerLottery && awardNum > 4"
                    :data="bigWheelRewardList"
                    :class-option="classOption"
                    class="horizontal-awards-scroll">
                    <ul class="ul-item">
                        <template v-for="(item, index) in bigWheelRewardList">
                            <!--未中奖，不展示-->
                            <li v-if="item.goodsType !== '0'"
                                :key="index"
                                class="li-item">
                                <img :src="item.imgUrl">
                                <div class="ellipsis ellipsis-two">{{ item.goodsName }}</div>
                            </li>
                        </template>
                    </ul>
                </vueSeamlessScroll>
            </div>

            <!-- 会员信息和中奖记录（共用） -->
            <div class="member-style">
                <!-- 查询到会员信息时，才显示积分情况 -->
                <div v-if="memberInfo"
                    class="member-info"
                    :style="{'background': bigWheelActivityType == '2' || tigerLottery ? '#FFF' : '#ffffff92'}">
                    <div class="points">您的剩余积分：<span>{{ pointsValue }}</span></div>
                </div>
                <!-- 中奖记录条数大于0时显示 -->
                <div v-if="myRecords.length>0"
                    class="winning-info"
                    :style="{'padding-top': memberInfo ? '0' : '20px'}">
                    <!-- 活动为大转盘时，bigWheelActivityType：1 大转盘，2 盲盒， 3 轮盘锦鲤（tigerLottery=true） -->
                    <p v-if="bigWheelActivityType == '1'"
                        style="width：100%;text-align: center">
                        <span style="font-size: 18px;color: #333333;text-align: center;font-weight: 600;">我的中奖记录</span>
                    </p>
                    <!-- 活动为盲盒或轮盘锦鲤时 -->
                    <div v-if="bigWheelActivityType == '2' || tigerLottery"
                        :class="tigerLottery ? 'tiger-prizes-title' : 'blindBox-prizes-title' "
                        class="blindBox-info-title"
                        :style="{'color': sectionThreeColor}">
                        <div>我的中奖记录</div>
                    </div>
                    <!-- 奖品列表 -->
                    <div class="list">
                        <ul style="max-height: 180px; overflow-y: auto;">
                            <li v-for="(item,index) in myRecords"
                                :key="index">
                                <!-- 中奖时间 -->
                                <div class="listItemLeft">
                                    {{ item.creationDate.slice(0,10) }}
                                </div>
                                <!-- 积分 | 奖品名称 -->
                                <div class="ellipsis listItemCenter">
                                    <span v-if="item.rewardType == '4'">{{ item.pointValue }}积分</span>
                                    <span v-else>{{ item.rewardName }}</span>
                                </div>
                                <div class="listItemRight">
                                    <!-- 查看按钮，奖品为积分时不显示 -->
                                    <template v-if="item.rewardType != '4'">
                                        <!-- 大转盘 -->
                                        <span v-if="bigWheelActivityType == '1'"
                                            class="actionBtn"
                                            @click="viewRecord(item)">查看</span>
                                        <!-- 盲盒或轮盘锦鲤 -->
                                        <span v-if="bigWheelActivityType == '2' || tigerLottery"
                                            :style="{'background': sectionThreeColor}"
                                            :class="tigerLottery ? 'tiger-btn' : 'blindBox-btn'"
                                            class="blindBox-info-btn"
                                            @click="viewRecord(item)">查看</span>
                                    </template>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- 活动规则（共用） -->
            <div class="list-wrap activity-rules"
                v-if="bigWheelRewardList.length > 0">
                <div class="container">
                    <p style="width: 100%;text-align: center"
                        v-if="bigWheelActivityType == '1'">
                        <span style="font-size: 18px;color: #333333;text-align: center;font-weight: 600;">活动规则</span>
                    </p>
                    <div v-if="bigWheelActivityType == '2' || tigerLottery"
                        :class="tigerLottery ? 'tiger-prizes-title' : 'blindBox-prizes-title' "
                        class="blindBox-info-title"
                        :style="{'color': sectionThreeColor}">
                        <div>活动规则</div>
                    </div>
                    <div class="ruleWrapper">
                        <!-- 20230112刘赟要求不显示活动时间和抽奖规则 -->
                        <!-- <div v-if="bigWheelActivityType == '2' || tigerLottery">活动时间： {{activityTime}}</div>
              <div v-if="bigWheelActivityType == '2' || tigerLottery">抽奖细则：</div> -->
                        <!-- pc端支持富文本编辑可能包含图片等 -->
                        <div class="ruleImg"
                            v-html="ruleDesci"></div>
                    </div>
                </div>
            </div>
            <div class="bottom-text"></div>
        </div>

        <!--大转盘奖品图片插入模板-->
        <div>
            <img v-for="(item,index) in turnplate.imgs"
                :id="'img' + index"
                :key="index"
                :src="item"
                hidden
                alt=""
                style="width: 100%;">
        </div>
        <!-- 中奖弹框 虚拟奖品 -->
        <virtualAwardModal :awardObj="awardObj"
            :activityObj="activityObj"
            :modalButtonText="modalButtonText"
            ref="virtualAwardModal"
            @refreshRecord="getRecord"
            @nextStep="nextStep">
        </virtualAwardModal>
        <!-- 实物中奖用户信息录入 -->
        <kindAwardModal :awardObj="awardObj"
            :activityObj="activityObj"
            :modalButtonText="modalButtonText"
            ref="kindAwardModal"
            :referrFlag="userBase.referrFlag"
            @refreshRecord="getRecord"
            @nextStep="nextStep"></kindAwardModal>
        <!-- 中奖弹框 未中奖 -->
        <noAwardModal :awardObj="awardObj"
            :activityObj="activityObj"
            :modalButtonText="modalButtonText"
            ref="noAwardModal"
            @refreshRecord="getRecord"
            @nextStep="nextStep">
        </noAwardModal>
        <!-- 中奖弹框 积分 -->
        <pointModal :awardObj="awardObj"
            :activityObj="activityObj"
            :modalButtonText="modalButtonText"
            ref="pointModal"
            @refreshRecord="getRecord"
            @nextStep="nextStep"></pointModal>
        <!-- 中奖弹框 实物奖品 -->
        <receiveAwardModal :activityUrl="activityUrl"
            :awardObj="awardObj"
            :activityObj="activityObj"
            :drawType="drawType"
            :modalButtonText="modalButtonText"
            ref="receiveAwardModal"
            :miniFlag="miniprogramFlag"
            @openKindAwardModal="openKindAwardModal"></receiveAwardModal>
        <!-- 中奖弹框 优惠券/代金券 -->
        <couponModal :awardObj="awardObj"
            :isLoginFlag="isLoginFlag"
            :activityObj="activityObj"
            :modalButtonText="modalButtonText"
            ref="couponModal"
            @nextStep="nextStep"></couponModal>
        <!-- 虚拟奖品用户信息录入弹窗 -->
        <virtualizedAwardModal :activityUrl="activityUrl"
            :awardObj="awardObj"
            :userInfoList="userInfoList"
            :activityObj="activityObj"
            :drawType="drawType"
            :modalButtonText="modalButtonText"
            ref="virtualizedAwardModal"
            @openVirtualAwardModal="openVirtualAwardModal"
            :miniFlag="miniprogramFlag"
            :referrFlag="userBase.referrFlag"
            @refreshRecord="getRecord"
            @nextStep="nextStep"></virtualizedAwardModal>
        <!-- 分享指引 -->
        <guideModal ref="guideModal"
            :isWechat="!miniprogramFlag && loginType == 'wechat'"></guideModal>
    </div>
    <div v-else>
        <login-in v-if="loginType==='wechat'"
            :isLoginFlag="isLoginFlag"
            :activityTypeFlag="activityTypeFlag"
            :activityUrl="activityUrl"></login-in>
        <!-- :userLotteryNum="userLotteryNum" -->
        <timed-draw :newBlindBoxData="newBlindBoxData"
            :regularDrawShowStatus="regularDrawShowStatus"
            :showEndPage="showEndPage"
            :myRecord="myRecord"
            :drawType="drawType"
            :activityStatus="activityStatus"
            :drawPointConsumption="drawPointConsumption"
            :balancePonits="pointsValue"
            :participateTimes="Number(participateTimes)"
            :miniprogramFlag="miniprogramFlag"
            :pointDrawFlag="pointDrawFlag"
            :userNum="userNum"
            :userWinNum="userWinNum"
            :loginType="loginType"
            :userBase="userBase"
            :newWinnerList="newWinnerList"
            :activityUrl="activityUrl"
            :newWinningRate="winningRate"
            :isLoginFlag="isLoginFlag"
            @closeEnd="closeEnd"
            @pointer="pointer"
            @openGuide="openGuide"
            @goWinnerList="goWinnerList"
            @goHiHonorMiniProgram="goHiHonorMiniProgram"
            @nextStep="nextStep">
        </timed-draw>
        <!-- 分享指引 -->
        <guideModal ref="guideModal"
            :isWechat="!miniprogramFlag && loginType == 'wechat'"></guideModal>
    </div>

</template>

<script type="text/ecmascript-6">
// 添加和移除事件的监听方法
const EVENT = {
  // 添加
  addHandler(element, type, handler) {
    if (element.addEventListener) {
      element.addEventListener(type, handler, false);
    } else if (element.attachEvent) {
      // 兼容ie
      element.attachEvent('on' + type, handler);
    } else {
      element['on' + type] = handler;
    }
  },

  // 移除
  removeHandler(element, type, handler) {
    if (element.removeEventListener) {
      element.removeEventListener(type, handler, false);
    } else if (element.detachEvent) {
      // 兼容ie
      element.detachEvent('on' + type, handler);
    } else {
      element['on' + type] = null;
    }
  },
};

import 'jquery';
import { awardRotate } from '../../../../static/runtime/js/awardRotate';
import virtualAwardModal from './dynamicAttr/modal/virtualAwardModal';
import guideModal from './dynamicAttr/modal/guideModal';
import kindAwardModal from './dynamicAttr/modal/kindAwardModal';
import virtualizedAwardModal from './dynamicAttr/modal/virtualizedAwardModal';
import noAwardModal from './dynamicAttr/modal/noAwardModal';
import pointModal from './dynamicAttr/modal/pointModal';
import loginIn from './dynamicAttr/modal/login-in.vue';
import receiveAwardModal from './dynamicAttr/modal/receiveAwardModal';
import couponModal from './dynamicAttr/modal/couponModal';
import { Dialog, Toast, NoticeBar, Swipe, SwipeItem } from 'vant';
import wx from 'weixin-js-sdk';
import utils from '@/utils/comUtils.js';
import tigerMachineLottery from './tiger-machine-lottery.vue';
import vueSeamlessScroll from 'vue-seamless-scroll';
import { config as configEnv } from '../../../commons/config.js';
import { config } from '@/api/config.js';
import timedDraw from './timedDraw/index.vue';
import { loadAlipayWebViewScript } from '../../../utils/comUtils.js';
import { LoginType } from '../../../commons/commonVariables';
export default {
  name: 'awardRotate',
  props: {
    activityObj: Object,
  },
  data() {
    return {
      nextFlag: '',
      activityTypeFlag: '',
      isLoginFlag: false, // 默认没有登录
      isOutDateList: {}, // (实物-线上邮寄)奖品是否超过有效期
      guideLotteryUrl: '', // 引导图
      // regularDrawShowStatus 1.活动结束后,用户有中奖;2.活动结束后,用户未中奖;3.活动已结束,但是用户未参与过活动;
      // 4.活动进行中,用户无次数;5.活动进行中,用户有次数;6.活动已结束,但是活动中奖逻辑还在计算中(开奖中)
      regularDrawShowStatus: '',
      headerList: null, // 参与用户头像
      userNum: null, // 参与抽奖人数
      userWinNum: null,
      // 是否是轮盘锦鲤抽奖
      tigerLottery: false,
      // 轮盘锦鲤抽奖类型
      tigerDraw: '3',
      // 轮盘锦鲤第三段颜色
      sectionThreeColor: '',
      // 轮盘锦鲤第二段颜色 #AE7B6E
      tigerBgColor: '',
      // 老虎机抽奖，用户中奖信息展示条数
      tigerWinningListLength: 20,
      // 无缝滚动组件配置项
      classOption: {
        // 开启无缝滚动的数据量
        limitMoveNum: 4,
        // 向左滚动
        direction: 2,
        // 滚动速度，值越大速度越快
        step: 0.8,
        openTouch: false,
        hoverStop: false,
      },
      defaultAvatar: window.location.origin + '/static/userImg.png',
      drawWheelUrl: '',
      drawPointUrl: '',
      msg: '',
      turnplate: {
        imgs: [],
        restaraunts: [],
        colors: [],
        outsideRadius: 190,
        textRadius: 155,
        insideRadius: 42,
        startAngle: 0,
        bRotate: false,
      },
      winnerList: [],
      myRecord: [],
      myRecords: [],
      bigWheelRewardList: [],
      ruleDesc: '',
      bannerPic: '',
      bgColor: '#eee',
      activityCode: '',
      userBase: {},
      hasNextActivityFlag: false,
      nextActivityCode: '',
      awardObj: {},
      participateTimes: 0,
      drawType: 'initDraw',
      drawPointConsumption: 0,
      balancePonits: 0,
      participateType: '', // 抽奖类型(1 初始化抽奖，2 积分抽奖 3 全部  4 订单抽奖 5 每日抽奖 6 分享抽奖)
      activityStatus: 1, // 活动状态 0 未开始 1 进行中 2 暂停中 3 已结束
      reFresh: false,
      canDrawFlag: false, // getDrawInfo 接口返回的 flag 字段：true -> 可以抽奖，false -> 不可以抽奖
      wrapperHeight: 0,
      // activityObj: {},
      drawCode: '', //多门店抽奖code
      channelCode: '', //门店编码
      modalShowFlag: false, //是否显示中奖弹窗
      miniprogramFlag: false, //判断是否在小程序打开
      isShowBackBtn: false, //判断是否显示返回按钮
      wxOpenLaunchWeappHiHonor: '',
      wxOpenLaunchWeappBrandStore: '',
      loginType: '',
      shareType: '',
      timeInterval: '',
      timeTimeout: '',
      memberInfo: '', // 会员信息
      activityUrl: '', // 当前活动地址
      pointDrawFlag: false, // false -> 可正常抽奖，true -> 积分抽奖，但是条件不满足，比如当前用户不是会员
      windowHiddenFlag: false, // 页面是否隐藏至后台
      windowShowFlag: false, // 是否打开或回到当前页面
      bigWheelActivityType: 1, // 抽奖类型 1 => 大转盘   2 => 盲盒  3=> 轮盘锦鲤 4 => 新盲盒
      staticImg: [
        '../../../../static/runtime/images/magic/award/diyModalBg.png',
        '../../../../static/runtime/images/magic/award/diyModalButton.png',
        '../../../../static/runtime/images/magic/award/zjjl_tc_bg.png',
        '../../../../static/runtime/images/magic/award/awardBg3.png',
        '../../../../static/runtime/images/magic/award/awardBg1.png',
        '../../../../static/runtime/images/magic/award/awardBg2.png',
      ],
      activityUrlTypel: '', // 多门店时是否产生多条链接 1 => 是   2 => 否
      boxIndex: '', // 当前点击盲盒的标号
      awardNum: 0, // 奖品的个数
      miniType: '', //小程序类型  1 => 体验店  2 => 直营店
      winRewardGoods: {}, //奖品记录
      remainingSharingTimes: '',
      drawResultsMessage: false, // 盲盒活动，用户是否选择永久订阅消息
      drawWheelType: '', // 大转盘抽奖类型，1：普通抽奖；2：整点购抽奖；3：定时开奖
      winningRate: 0, // 中奖率 （定时抽奖中，如果中奖率 > 1 则会展示）
      hasMask: false, // 定时抽奖 除只配置初始化抽奖情况 控制是否显示遮罩
      whetherActivity: false, // 用户是否参与过活动 true 用户参与过 false 没有参与
      newBlindBoxData: {}, //新盲盒的数据，往组件内部传
      showEndPage: false,
      newWinnerList: [],
      env: configEnv.env,
      envVersion: config.env === 'pro' ? 'release' : 'trial',
      hiHonorWxAppId: config.otherConfig.hiHonorWxAppId,
      communityUserStatus: -1,
      jumpNextPageType: '', //转盘抽奖后跳转下级页面设置：0抽奖后展示下一级 1抽奖机会=0展示下一级
      userInfoList: [],
      tips: '',
    };
  },
  created() {
    this.loginType = sessionStorage.getItem('loginType') || '';
    this.shareType = sessionStorage.getItem('shareType') || '';
    this.activityCode = (this.activityObj && this.activityObj.activityCode) || '';
    console.log('created==>activityObj', this.activityObj);

    this.activityTypeFlag = sessionStorage.getItem('activityTypeFlag') || '1';

    if (this.loginType === 'wechat') {
      this.isLoginFlag = sessionStorage.getItem('isLoginFlag') === 'true' ? true : false;
    }
    const code = this.$route.query.activityCode;
    if (code && code.indexOf('_') > -1) {
      this.drawCode = code;
    }
    // 组装当前地址
    this.activityUrl = location.origin + '/hd/hdmain?activityCode=' + code;
    if (this.drawCode) {
      this.channelCode = this.drawCode.split('_')[1];
    }
    const self = this;
    // let userBase = self.$store.state.userInfo.userBase;
    let userBase = {};
    let userInfo = sessionStorage.getItem('userInfo');

    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      userBase = Object.assign(userBase, userInfo);
    }

    //荣耀推荐官登录信息
    let recommendUserInfo = sessionStorage.getItem('recommendUserInfo');
    if (recommendUserInfo) {
      recommendUserInfo = JSON.parse(recommendUserInfo);
      userBase = Object.assign(userBase, recommendUserInfo);
    }
    self.userBase = userBase;
    self.userBase.userType = sessionStorage.getItem('userType');
    // userType 是抽奖对象（1 -> 荣耀会员，2 -> 全部用户），会员才有积分
    self.userBase.referrFlag = self.userBase.userType == '2' ? '1' : '0';
    console.log('awardRotate-userBase-before:', userBase);
    this.getLotty();
    this.getAllData();
    console.log('awardRotate-userBase-after:', userBase);
    // 判断是否在小程序内
    this.handleMiniprogramJudge();
    console.log('miniprogramFlag', this.miniprogramFlag);
    const isFromCustomForm = sessionStorage.getItem('isFromCustomForm') || '';
    //微信浏览器嵌入h5，并且是从自定义表单跳转
    if (isFromCustomForm == '1' && !this.miniprogramFlag && this.loginType == 'wechat') {
      window.setTimeout(() => {
        sessionStorage.setItem('isFromCustomForm', '');
        console.log('微信浏览器嵌入h5，来自自定义表单跳转来的，重刷大转盘页面->>');
        const path = '/hdmain?activityCode=' + code;
        this.$router.push({
          path: path,
        });
        this.$store.commit('base/setIsRouterAlive', false);
        this.$nextTick(() => this.$store.commit('base/setIsRouterAlive', true));
      }, 400);
    }
    setTimeout(() => {
      if (!this.miniprogramFlag) {
        this.wxOpenLaunchWeappHiHonor = `<wx-open-launch-weapp id="launch-btn" env-version="${this.envVersion}" username=${this.hiHonorWxAppId} path="subpackages/my/pages/rewardQuery/reward-query"><template><style>.btn { width: 1000px;height: 300px; opacity: 0;}</style><button class="btn">打开小程序</button> </template> </wx-open-launch-weapp>`;
        this.wxOpenLaunchWeappBrandStore = `<wx-open-launch-weapp id="launch-btn" env-version="${this.envVersion}" username="gh_c31414cf312a" path="pageMyCenter/rewardQuery/rewardQuery"><template><style>.btn { width: 1000px;height: 300px; opacity: 0;}</style><button class="btn">打开小程序</button> </template> </wx-open-launch-weapp>`;
      }
    }, 500);
  },
  mounted() {
    console.log('当前env', this.env);
    // 微信登录后才调用接口-接口有校验
    if (this.isLoginFlag && this.loginType == 'wechat') {
      this.getAwardTimeStatus();
    } else if (this.loginType !== 'wechat') {
      this.getAwardTimeStatus();
    }
    if (!this.miniprogramFlag) {
      this.wxConfig();
    }
    this.$nextTick(() => {
      const dragBox = document.getElementById('signCorner');
      if (dragBox) {
        const rect = dragBox.getBoundingClientRect();
        const xPosition = sessionStorage.getItem('xPosition');
        const yPosition = sessionStorage.getItem('yPosition');
        if (xPosition) {
          dragBox.style.right = xPosition;
          dragBox.style.top = yPosition;
        }
        //拖拽中
        dragBox.addEventListener(
          'touchmove',
          function (event) {
            event.preventDefault(); //阻止其他事件
            // 如果这个元素的位置内只有一个手指的话
            if (event.targetTouches.length == 1) {
              const touch = event.targetTouches[0];
              // 元素与手指位置同步
              // dragBox.style.left = touch.clientX + 'px';
              dragBox.style.right = 0 + 'px';
              dragBox.style.top = touch.clientY - rect.height / 2 + 'px';
              //由于页面中会有滚动，所以在这不能用pageX和pageY,要用clientX  clientY
            }
          },
          false
        );

        //拖拽结束，放手
        dragBox.addEventListener(
          'touchend',
          function (event) {
            // 如果这个元素的位置内只有一个手指的话
            //拖拽结束，changedTouches列表是涉及当前事件的列表
            if (event.changedTouches.length == 1) {
              const touch = event.changedTouches[0];
              // 判断手指位置，放置元素，如果大于浏览器宽度的一半，则右贴边，小于等于则左贴边
              // 手指位置判断,竖直方向，超出屏幕的贴边，水平方向，超出屏幕贴边，
              dragBox.style.right = 0 + 'px';
              if (touch.clientY - rect.height / 2 <= 0) {
                dragBox.style.top = 0 + 'px';
              } else if (touch.clientY >= window.innerHeight - rect.height) {
                dragBox.style.top = window.innerHeight - rect.height - 20 + 'px';
              }
            }
            dragBox.touchmove = null;
            dragBox.touchend = null;
            sessionStorage.setItem('xPosition', dragBox.style.right);
            sessionStorage.setItem('yPosition', dragBox.style.top);
          },
          false
        );
      }
    });
  },
  watch: {
    winnerList() {
      this.reFresh = false;
      this.$nextTick(() => {
        this.reFresh = true;
      });
    },

    // false -> 可正常抽奖，true -> 积分抽奖，但是当前用户不是会员
    pointDrawFlag(nVal) {
      if (nVal) {
        // 不满足积分抽奖则添加监听事件，以便于从小程序入会回来后可以刷新页面
        // 刷新页面是为了当前页面再次获取用户是否入会
        // 结合监听事件做出类似与小程序 onShow 的效果
        EVENT.addHandler(document, 'visibilitychange', () => {
          if (document.visibilityState == 'hidden') {
            // 页面隐藏，隐藏时要把 windowShowFlag 初始化
            this.windowHiddenFlag = true;
            this.windowShowFlag = false;
          }
          if (document.visibilityState == 'visible') {
            // 页面显示
            this.windowShowFlag = true;
          }
          if (this.windowHiddenFlag && this.windowShowFlag) {
            // 两个都是 true 的时候，说明页面就是从其他页面返回或从后台再次显示至屏幕
            // 这个时候再刷新页面，重新请求接口
            location = location;
          }
        });
      }
    },
  },
  destroyed() {
    // 组件销毁时，需要移除页面事件监听
    EVENT.removeHandler(document, 'visibilitychange', () => {});
  },
  components: {
    loginIn,
    awardRotate,
    virtualAwardModal,
    kindAwardModal,
    noAwardModal,
    pointModal,
    receiveAwardModal,
    couponModal,
    virtualizedAwardModal,
    [Dialog.Component.name]: Dialog.Component,
    tigerMachineLottery,
    NoticeBar,
    Swipe,
    SwipeItem,
    vueSeamlessScroll,
    guideModal,
    timedDraw,
  },
  computed: {
    // 老虎机抽奖，用户中奖信息,只取前20条数据
    tigerWinningList() {
      if (this.winnerList.length > this.tigerWinningListLength) {
        return this.winnerList.slice(0, this.tigerWinningListLength + 1);
      } else {
        return this.winnerList;
      }
    },
    // 是否需要预约导购
    isGuideFlag() {
      return this.winRewardGoods.appointmentFlag === '1';
    },
    ruleDesci: function () {
      if (this.ruleDesc.indexOf('<a href=') != -1) {
        this.ruleDesc = this.ruleDesc.replace(/<a [^>]*href=['"]([^'"]+)[^>]*>/g, function (match, capture) {
          const result = capture;
          return '<a href=' + result + ' rel="noopener noreferrer" target="_blank">';
        });
      }
      return this.ruleDesc.replace(/↵/g, '<br/>').replace(/\n/g, '<br/>').replace(/ihlp/g, 'hd');
    },
    poinsOrDiamonds: function () {
      // return this.userBase.referrFlag === '1' ? '钻石' : '积分';
      return '积分';
    },
    pointsValue() {
      return String(this.memberInfo.pointsValue).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    activityTime() {
      const activityStartTime =
        this.activityObj && this.activityObj.activityStartTime
          ? this.activityObj.activityStartTime.replace(/(\d{4}).(\d{1,2}).(\d{1,2}).+/gm, '$1年$2月$3日')
          : '';
      const activityEndTime =
        this.activityObj && this.activityObj.activityEndTime ? this.activityObj.activityEndTime.replace(/(\d{4}).(\d{1,2}).(\d{1,2}).+/gm, '$1年$2月$3日') : '';
      return activityStartTime + ' - ' + activityEndTime;
    },
    getButtonBgStyle() {
      return {
        'border-color': this.activityObj.extendConfig.awardListButtonColor || '#ffffff',
        color: this.activityObj.extendConfig.awardListButtonColor || '#ffffff',
      };
    },
    modalButtonText() {
      return this.getjumpText();
    },
  },
  methods: {
    getjumpText() {
      if (this.awardObj.jumpType === '0' || this.awardObj.jumpType === '4') {
        return '去使用';
      } else if (this.awardObj.jumpType === '1') {
        // 线上邮寄
        if (this.awardObj.rewardType === '2' && this.awardObj.collectionType === '1' && !this.awardObj.extendConfigFlag) {
          return '提交';
        }
        if (this.awardObj.rewardType === '2' && this.awardObj.collectionType === '1' && this.awardObj.extendConfigFlag) {
          return '确认';
        }
        return '确认';
      } else if (this.awardObj.jumpType === '2') {
        // 线上邮寄
        if (this.awardObj.rewardType === '2' && this.awardObj.collectionType === '1' && !this.awardObj.extendConfigFlag) {
          return '提交';
        }
        if (this.awardObj.rewardType === '2' && this.awardObj.collectionType === '1' && this.awardObj.extendConfigFlag) {
          return '确认';
        }
        // 门店自提
        if (this.awardObj.rewardType === '2' && this.awardObj.collectionType === '2') {
          return '确认';
        }
        return '下一步';
      } else if (this.awardObj.jumpType === '9') {
        // 线上邮寄
        if (this.awardObj.rewardType === '2' && this.awardObj.collectionType === '1' && !this.awardObj.extendConfigFlag) {
          return '提交';
        }
        if (this.awardObj.rewardType === '2' && this.awardObj.collectionType === '1' && this.awardObj.extendConfigFlag) {
          return '确认';
        }
        // 到店自提，虚拟，线上核销,线上兑换
        if (
          (['1', '2'].includes(this.awardObj.rewardType) && ['2', '3'].includes(this.awardObj.collectionType)) ||
          (this.awardObj.rewardType === '1' && this.awardObj.collectionType === '1')
        ) {
          return '确认';
        }
        if (this.awardObj.collectionType === '4' && ['3', '4'].includes(this.awardObj.drawOrderSource)) {
          return '确认';
        }
        return '我知道了';
      } else {
        return '我知道了';
      }
    },
    // （实物&&线上邮寄）奖品是否超过有效期
    getAwardTimeStatus() {
      this.$api.post({
        noLoading: true,
        sc: 'mobileMarketing',
        url: 'h5/bigWheel/reward/record/all/get',
        params: {
          activityCode: this.activityObj.activityCode,
          userOpenid: this.loginType == 'wechat' ? this.userBase.openId || '' : '',
          alipayUserId: this.loginType == 'Alipay' ? sessionStorage.getItem('alipayUserId') || '' : '',
          loginType: this.loginType || '',
          channelCode: this.channelCode,
        },
        success: (r) => {
          if (r.code == 200 && r.result && r.result.bigwheelRewardRecordDetailsDtoList && r.result.bigwheelRewardRecordDetailsDtoList.length) {
            this.isOutDateList = {};
            const arr = r.result.bigwheelRewardRecordDetailsDtoList;
            arr.forEach((el) => {
              this.isOutDateList[el.bigwheelRewardRecodeId] = el.effectiveEndTime ? new Date() > new Date(el.effectiveEndTime) : false;
            });
          }
          if (r.code == 200 && r.result && r.result.bigwheelRewardRecordDtoList.length) {
            this.newWinnerList = r.result.bigwheelRewardRecordDtoList;
          }
        },
      });
    },
    pullUp() {
      const btn = document.getElementById('subscribe-btn');
      btn.addEventListener('success', function (e) {
        console.log('success', e.detail);
      });
      btn.addEventListener('error', function (e) {
        console.log('fail', e.detail);
      });
    },
    //打开分享引导提示
    openGuide() {
      this.$refs.guideModal.openModel();
    },
    // 埋码事件：抽奖结果
    handleClickResultAwardRotateProcess(award) {
      const awardItem = {
        0: '未中奖',
        1: '虚拟奖品',
        2: '实物奖品',
        3: '优惠券奖品',
        4: '积分奖品',
      };
      let params = {
        actionCode: '400060002',
        actionName: '抽奖结果',
        content: {
          title: '大转盘抽奖结果',
          channel: this.loginType === 'undefined' ? '' : this.loginType == 'wechat' ? '微信' : '支付宝',
          shareType: this.shareType === 'undefined' ? '' : this.shareType,
          awardType: awardItem[award.goodsType],
          awardName: award.goodsType === '3' ? award.activationCode : award.goodsName,
          activityCode: this.activityCode,
        },
      };
      // 如果session缓存中存在eventTrackingData，则将storeCode存入content中
      const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData'));
      if (eventTrackingData && eventTrackingData.storeCode) {
        params.content.channelCode = eventTrackingData.storeCode;
      }
      utils.handleBatchReport(this, params);
    },
    goWinnerList() {
      const path = `/winnerList?activityCode=${this.activityObj.activityCode}&openId=${this.userBase.openId}&channelCode=${this.channelCode}&isUsed=${this.activityObj.isUsed}`;
      this.$router.push({
        path: path,
      });
    },
    // 查询会员信息
    queryMemberInfo() {
      const params = {
        uniqId: this.loginType == 'wechat' ? this.userBase.unionid || '' : this.userBase.userId || '',
        idType: this.loginType == 'wechat' ? '1' : '6',
      };
      this.$api.post({
        noLoading: true,
        sc: 'member2',
        url: 'memberInfoMiniManage/queryMemberInfoByUnionIdAndIdType',
        params,
        success: (res) => {
          this.memberInfo = res.result;
        },
      });
    },
    async getAllData() {
      const self = this;
      let channelCode = '';
      if (this.drawCode) {
        channelCode = this.drawCode.split('_')[1];
      }
      if (!channelCode && this.activityObj.isUsed === '1') {
        channelCode = sessionStorage.getItem('navChannelCode');
      }

      const data = await self.checkLottyChannel(this.activityObj.activityCode, channelCode);
      if (!data.result) {
        self.modalShowFlag = true;

        Dialog.confirm({
          title: '提示',
          message: '您已达到本次抽奖活动的最大抽奖次数,感谢您的支持！',
        }).then(() => {
          const extendConfig = JSON.parse(self.activityObj.extendConfigStr);
          if (this.jumpNextPageType) {
            self.hasNextActivityFlag = true;
            // self.nextActivityCode = extendConfig.nextActivity || extendConfig.nextUrl;
            self.nextStep();
          }
        });
      }
      if (this.activityObj.isUsed === '1' && sessionStorage.getItem('associationActivityCode')) {
        const data2 = await self.checkLottyTimes();
        if (!data2.result) {
          self.modalShowFlag = true;

          Dialog.confirm({
            title: '提示',
            message: '您已达到本次抽奖活动的最大抽奖次数,感谢您的支持！',
          }).then(() => {
            const extendConfig = JSON.parse(self.activityObj.extendConfigStr);
            if (this.jumpNextPageType) {
              self.hasNextActivityFlag = true;
              self.nextStep();
            }
          });
        }
      }

      function getChance() {
        let activityCode = self.drawCode || self.activityObj.activityCode;
        if (
          !self.drawCode &&
          self.activityObj.isUsed === '1' &&
          self.activityObj.channelFlag === '2' &&
          sessionStorage.getItem('associationActivityCode') &&
          sessionStorage.getItem('navChannelCode') &&
          self.activityObj.activityUrlTypel == '1'
        ) {
          activityCode = `${self.activityObj.activityCode}_${sessionStorage.getItem('navChannelCode')}`;
        }
        return new Promise((resolve, reject) => {
          self.$api.post({
            noLoading: true,
            sc: 'mobileMarketing',
            url: 'h5/bigWheel/getDrawInfo',
            params: {
              activityCode: activityCode,
              openId: self.loginType == 'wechat' ? self.userBase.openId || '' : '',
              unionid: self.loginType == 'wechat' ? self.userBase.unionid || '' : '',
              alipayUserId: self.loginType == 'Alipay' ? sessionStorage.getItem('alipayUserId') || '' : '',
              loginType: self.loginType || '',
              loginSide: self.loginType === LoginType.Wechat ? 'wxapp' : self.loginType === LoginType.Alipay ? 'alipaymini' : '',
              referrFlag: self.userBase.referrFlag ? self.userBase.referrFlag : 0,
              channelCode: channelCode,
              memberCode: self.userBase.memberCenterId,
            },
            success: (r) => {
              resolve(r);
              if (r && r.result && r.result.drawResultsMessage) {
                self.drawResultsMessage = r.result.drawResultsMessage;
              }
              if (r && r.result && r.result.tips) {
                self.tips = r.result.tips;
              }
            },
          });
        });
      }
      function getRecord() {
        return new Promise((resolve, reject) => {
          self.$api.post({
            noLoading: true,
            sc: 'mobileMarketing',
            url: 'h5/bigWheel/reward/record/all/get',
            params: {
              activityCode: self.activityObj.activityCode,
              userOpenid: self.loginType == 'wechat' ? self.userBase.openId || '' : '',
              alipayUserId: self.loginType == 'Alipay' ? sessionStorage.getItem('alipayUserId') || '' : '',
              loginType: self.loginType || '',
              channelCode: channelCode,
            },
            success: (r) => {
              resolve(r);
            },
          });
        });
      }
      if (this.userBase.member) {
        const res = await getChance();
        if (res && res.result) {
          const result = res.result;
          self.participateTimes = result.balanceTimes || 0;
          self.drawPointConsumption = Number(result.drawPointConsumption);
          self.drawType = result.drawType;
          self.canDrawFlag = result.flag;
          self.participateType = result.participateType;
          self.balancePonits = result.balancePonits;
          if (this.userBase.userType == '1' || this.userBase.userType == '3') {
            // 判断是否是会员，是则获取会员信息，否则页面给出入会提示
            if (this.userBase.member) {
              this.queryMemberInfo();
            } else {
              this.pointDrawFlag = true;
            }
          }

          if (result.balanceTimes == '0' && result.totalBalanceTimes > 0 && result.drawType === 'orderDraw') {
            Dialog.alert({
              title: '提示',
              message: '您已达到每天抽奖次数，请您明天再来！',
            });
          }
        }
      } else {
        this.pointDrawFlag = true;
      }
      let record = {};
      if (this.isLoginFlag && this.loginType == 'wechat') {
        record = await getRecord();
      } else if (this.loginType !== 'wechat') {
        record = await getRecord();
      }
      const myRecords = [];
      if (record && record.result) {
        // 处理隐私信息
        this.$utils.addAnonymizedText(record.result.bigwheelRewardRecordDtoList, ['nickName']);
        self.myRecord = JSON.parse(JSON.stringify(record.result.bigwheelRewardRecordDetailsDtoList));
        self.myRecord.filter((item) => {
          if (item.rewardType !== '0') {
            myRecords.push(item);
          }
        });
        self.myRecords = myRecords;
        console.log('self.myRecords====', self.myRecords);
        // prizeWinningScrollFlag  0 => 展示滚动，1 => 不展示
        if (self.activityObj.prizeWinningScrollFlag == 0) {
          // 取消掉用setInterval设置的重复执行动作
          clearInterval(self.timeInterval);
          // 方法可取消由 setTimeout() 方法设置的 timeout。
          clearTimeout(self.timeTimeout);
          setTimeout(() => {
            self.winnerList = JSON.parse(JSON.stringify(record.result.bigwheelRewardRecordDtoList));
            this.$nextTick(() => {
              if (this.winnerList.length > this.activityObj.prizeWinningNumbers) {
                this.horseRaceLamp('scrollBox');
              }
            });
          }, 0);
        }
      }
      // participateTimes有没有抽奖机会  whetherActivity有没有玩过活动 hasNextActivityFlag有没有下级页面 modalShowFlag有没有显示中奖弹窗
      // 抽奖机会=0，展示下一级 || 抽奖后，展示下一级
      if (
        (!self.participateTimes && self.whetherActivity && self.hasNextActivityFlag && self.jumpNextPageType === '1') ||
        (self.whetherActivity && self.hasNextActivityFlag && self.jumpNextPageType === '0')
      ) {
        this.getNextActivity();
      }
    },
    getNextActivity() {
      const myAward = this.myRecord[0];
      this.userInfoList = myAward.userInfoList || [];
      this.awardObj = Object.assign({ singleFlag: true }, myAward);
      if (this.awardObj.collectionType !== '4') {
        this.awardObj.drawOrderSource = null;
      }
      this.awardObj.bigWheelActivityType = Number(this.bigWheelActivityType);
      if (myAward && myAward.rewardType === '0') {
        this.$refs.noAwardModal.openModel();
      } else if (myAward && myAward.rewardType == 1) {
        if (['2', '3', '4'].includes(myAward.collectionType)) {
          this.$refs.virtualizedAwardModal.openModel({
            flag: true,
            codeId: this.awardObj.exchangeActivationCodeId,
            type: myAward.collectionType,
            ...this.awardObj,
          });
        } else {
          // 已填写姓名手机号就弹出兑换码，没填就弹窗录入姓名手机号
          if (myAward.rewardRecordextendConfigPrivacy) {
            this.$refs.virtualAwardModal.openModel();
          } else {
            //没有展示虚拟客户需要录入信息的弹框
            this.$refs.virtualizedAwardModal.openModel();
          }
        }
      } else if (myAward && myAward.rewardType == 2) {
        let extendConfig = myAward.extendConfig || {};
        if (myAward.extendConfigFlag) {
          extendConfig = JSON.parse(myAward.extendConfig);
        }
        if (myAward.rewardRecordextendConfigPrivacy) {
          extendConfig.userName = myAward.rewardRecordextendConfigPrivacy.userName;
          extendConfig.userPhone = myAward.rewardRecordextendConfigPrivacy.userPhone;
          extendConfig.userAddress = myAward.rewardRecordextendConfigPrivacy.userAddress;
        }
        this.awardObj = Object.assign(extendConfig, myAward);
        this.awardObj.singleFlag = true;
        this.awardObj.bigWheelActivityType = Number(this.bigWheelActivityType);
        if (['2'].includes(myAward.collectionType)) {
          this.$refs.receiveAwardModal.openModel({
            flag: true,
            codeId: this.awardObj.exchangeActivationCodeId,
            type: myAward.collectionType,
            ...this.awardObj,
          });
        } else {
          this.$refs.kindAwardModal.openModel();
        }
      } else if (myAward && (myAward.rewardType == 3 || myAward.rewardType == 5)) {
        if (myAward.goodsPictureUrl) {
          let pic = JSON.parse(myAward.goodsPictureUrl);
          let imgItem = this.$utils.getImageUrl(pic.file);
          this.awardObj.imgItem = imgItem;
        }
        if (myAward.voucherStartDate && myAward.voucherEndDate) {
          this.awardObj.voucherStartDate = myAward.voucherStartDate;
          this.awardObj.voucherEndDate = myAward.voucherEndDate;
        }
        console.log('this.awardObj', this.awardObj);
        this.$refs.couponModal.openModel();
      } else if (myAward && myAward.rewardType === '4') {
        this.$refs.pointModal.openModel();
      } else if (myAward && myAward.rewardType === '6') {
        this.awardObj.collectionType = '2';
        // 赠品券
        this.awardObj.singleFlag = true;
        this.awardObj.bigWheelActivityType = Number(this.bigWheelActivityType);
        this.$refs.virtualizedAwardModal.openModel({
          flag: true,
          codeId: this.awardObj.exchangeActivationCodeId,
          type: myAward.collectionType,
          ...this.awardObj,
        });
      }
    },
    getChance() {
      let self = this;
      if (!self.channelCode && self.activityObj.isUsed === '1') {
        self.channelCode = sessionStorage.getItem('navChannelCode');
      }
      let activityCode = self.drawCode || self.activityObj.activityCode;
      if (
        !self.drawCode &&
        self.activityObj.isUsed === '1' &&
        self.activityObj.channelFlag === '2' &&
        sessionStorage.getItem('associationActivityCode') &&
        sessionStorage.getItem('navChannelCode') &&
        self.activityObj.activityUrlTypel == '1'
      ) {
        activityCode = `${self.activityObj.activityCode}_${sessionStorage.getItem('navChannelCode')}`;
      }
      self.$api.post({
        noLoading: true,
        sc: 'mobileMarketing',
        url: 'h5/bigWheel/getDrawInfo',
        params: {
          activityCode: activityCode,
          openId: self.loginType == 'wechat' ? self.userBase.openId || '' : '',
          unionid: self.loginType == 'wechat' ? self.userBase.unionid || '' : '',
          alipayUserId: self.loginType == 'Alipay' ? sessionStorage.getItem('alipayUserId') || '' : '',
          loginType: self.loginType || '',
          loginSide: self.loginType === LoginType.Wechat ? 'wxapp' : self.loginType === LoginType.Alipay ? 'alipaymini' : '',
          referrFlag: self.userBase.referrFlag ? self.userBase.referrFlag : 0,
          channelCode: self.channelCode,
          memberCode: self.userBase.memberCenterId,
        },
        success: (r) => {
          if (r && r.result) {
            let result = r.result;
            self.participateTimes = result.balanceTimes || 0;
            self.drawPointConsumption = Number(result.drawPointConsumption);
            self.drawType = result.drawType;
            self.canDrawFlag = result.flag;
            self.balancePonits = result.balancePonits;
            self.drawResultsMessage = result.drawResultsMessage;
            self.tips = r.result.tips;
            if (this.userBase.userType == '1' || this.userBase.userType == '3') {
              // 判断是否是会员，是则获取会员信息，否则页面给出入会提示
              if (this.userBase.member) {
                this.queryMemberInfo();
              } else {
                this.pointDrawFlag = true;
              }
            }
            if (result.balanceTimes == '0' && result.totalBalanceTimes > 0 && result.drawType === 'orderDraw') {
              Dialog.alert({
                title: '提示',
                message: '您已达到每天抽奖次数，请您明天再来！',
              });
            }
          }
        },
      });
    },
    // 查询抽奖页面信息，如活动名称，背景图片，奖品信息，登录类型（微信，支付宝）等
    getLotty() {
      let self = this;
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/bigWheel/queryActivityBigWheelActivityDetailH5',
        params: {
          activityCode: this.activityObj.activityCode,
          userOpenid: self.loginType == 'wechat' ? self.userBase.openId || '' : '',
          alipayUserId: self.loginType == 'Alipay' ? sessionStorage.getItem('alipayUserId') || '' : '',
        },
        success: (r) => {
          const { result, code, message } = r;
          if (code == 200 && result) {
            this.newBlindBoxData = result;
            const {
              extendConfigStr,
              activityStatus,
              activityPictureUrl,
              drawWheelUrl,
              drawPointUrl,
              bigWheelRewardList,
              bigWheelActivityType,
              activityUrlTypel,
              regularDrawShowStatus,
              headerList,
              userNum,
              userWinNum,
              remainingSharingTimes,
              guideLotteryUrl,
              winningRate,
              whetherActivity,
              communityUserStatus,
              // userLotteryNum
            } = result;
            this.communityUserStatus = communityUserStatus; //社群用户状态
            this.winningRate = winningRate || 0; // 中奖率
            this.regularDrawShowStatus = regularDrawShowStatus; // 定时开奖状态
            this.whetherActivity = whetherActivity; // 用户是否参与过活动
            // this.userLotteryNum = userLotteryNum || 0;
            if (this.userBase.userType === '3') {
              if (this.communityUserStatus === 0) {
                Dialog.alert({
                  message: '您未加入会员群，加入后获得抽奖机会',
                });
              } else if (this.communityUserStatus === 2) {
                Dialog.alert({
                  message: '您不是新用户，无法参与该活动',
                });
              }
            }
            if (whetherActivity) {
              this.hasMask = true;
            }
            this.headerList = headerList;
            this.userNum = userNum;
            this.userWinNum = userWinNum;
            this.remainingSharingTimes = remainingSharingTimes; //剩余分享次数
            this.headerList && this.headerList.length > 5 && (this.headerList.length = 5);
            this.guideLotteryUrl = guideLotteryUrl ? this.$utils.getImageUrl(JSON.parse(guideLotteryUrl).file) : null;
            // 抽奖类型 bigWheelActivityType 1 => 大转盘   2 => 盲盒  3 => 轮盘锦鲤   4 =.新盲盒
            this.bigWheelActivityType = bigWheelActivityType;
            // 是否为老虎机抽奖（轮盘锦鲤）
            this.tigerLottery = bigWheelActivityType === this.tigerDraw ? true : false;
            // 多门店时是否产生多条链接 1 => 是   2 => 否
            this.activityUrlTypel = activityUrlTypel;
            //小程序类型 1 => 体验店  2 => 直营店
            this.miniType = result.miniType;
            this.activityTypeFlag = result.miniType;
            //大转盘抽奖类型，1：普通抽奖；2：整点购抽奖；3：定时开奖
            this.drawWheelType = result.drawWheelType;
            let shareEveryDayLimit = 0;
            if (extendConfigStr) {
              const extendConfig = JSON.parse(extendConfigStr);
              const { bgColor, ruleDescri, ruleDescriUrl, participateType, jumpNextPageType } = extendConfig;
              this.bgColor = bgColor;
              this.jumpNextPageType = jumpNextPageType; //转盘抽奖后跳转下级页面设置：0抽奖后展示下一级 1抽奖机会=0展示下一级
              if (this.tigerLottery) {
                this.sectionThreeColor = bgColor;
              }
              this.ruleDesc = ruleDescri;
              if (this.jumpNextPageType) {
                this.hasNextActivityFlag = true;
              }
              if (participateType) {
                this.isShowBackBtn = participateType.indexOf('4') > -1 ? true : false;
              }
            }

            if (activityStatus === '1') {
              if (whetherActivity) {
                this.showEndPage = true;
              } else {
                this.showEndPage = false;
              }
            } else if (activityStatus === '3') {
              this.showEndPage = true;
            }

            this.activityStatus = activityStatus;
            if (activityPictureUrl) {
              this.bannerPic = this.$utils.getImageUrl(JSON.parse(activityPictureUrl).file);
              this.staticImg.push(this.bannerPic);
            }
            if (drawWheelUrl) {
              this.drawWheelUrl = this.$utils.getImageUrl(JSON.parse(drawWheelUrl).file);
              this.staticImg.push(this.drawWheelUrl);
            }
            if (drawPointUrl) {
              this.drawPointUrl = this.$utils.getImageUrl(JSON.parse(drawPointUrl).file);
              this.staticImg.push(this.drawPointUrl);
            }
            this.bigWheelRewardList = bigWheelRewardList;
            let len = bigWheelRewardList.length;
            for (let i = 0; i < len; i++) {
              this.turnplate.restaraunts[i] = '';
              this.turnplate.colors[i] = bigWheelRewardList[i].bgColor;
              if (bigWheelRewardList[i].goodsType != 0) {
                this.awardNum++;
              }
              if (bigWheelRewardList[i].goodsPictureUrl) {
                let pic = JSON.parse(bigWheelRewardList[i].goodsPictureUrl);
                let imgItem = this.$utils.getImageUrl(pic.file);
                this.bigWheelRewardList[i].imgUrl = imgItem;
                this.turnplate.imgs[i] = imgItem;
              } else {
                this.turnplate.imgs[i] = require('../../../../static/runtime/images/magic/award/zp_zjzl.png');
              }
            }
            let promiseAll = [];
            let img = [];
            let imgArr = [...this.turnplate.imgs, ...this.staticImg];
            for (let j = 0; j < len; j++) {
              promiseAll[j] = new Promise((resolve, reject) => {
                img[j] = new Image();
                img[j].src = imgArr[j];
                img[j].onload = function () {
                  console.log('第' + j + '张图片加载完成');
                  resolve(img[j]);
                };
              });
            }
            Promise.all(promiseAll).then((img) => {
              if (bigWheelActivityType == '1') {
                this.drawRouletteWheel();
              }
            });
          }
        },
      });
    },
    // 查询中奖记录
    getRecord() {
      let self = this;
      const myRecords = [];
      if (!self.channelCode && self.activityObj.isUsed === '1') {
        self.channelCode = sessionStorage.getItem('navChannelCode');
      }
      self.$api.post({
        noLoading: true,
        sc: 'mobileMarketing',
        url: 'h5/bigWheel/reward/record/all/get',
        params: {
          activityCode: self.activityObj.activityCode,
          userOpenid: self.loginType == 'wechat' ? self.userBase.openId || '' : '',
          alipayUserId: self.loginType == 'Alipay' ? sessionStorage.getItem('alipayUserId') || '' : '',
          loginType: self.loginType || '',
          channelCode: self.channelCode,
        },
        success: (r) => {
          if (r && r.result) {
            // 处理隐私信息
            self.$utils.addAnonymizedText(r.result.bigwheelRewardRecordDtoList, ['nickName']);
            self.myRecord = JSON.parse(JSON.stringify(r.result.bigwheelRewardRecordDetailsDtoList));
            self.myRecord.filter((item) => {
              if (item.rewardType !== '0') {
                myRecords.push(item);
              }
            });
            self.myRecords = myRecords;
            // prizeWinningScrollFlag  0 => 展示滚动，1 => 不展示
            if (self.activityObj.prizeWinningScrollFlag == 0) {
              clearInterval(self.timeInterval);
              clearTimeout(self.timeTimeout);
              setTimeout(() => {
                self.winnerList = JSON.parse(JSON.stringify(r.result.bigwheelRewardRecordDtoList));
                this.$nextTick(() => {
                  if (this.winnerList.length > this.activityObj.prizeWinningNumbers) {
                    this.horseRaceLamp('scrollBox');
                  }
                });
              }, 0);
            }
          }
        },
      });
    },
    viewRecord(item) {
      if (this.isOutDateList[item.bigwheelRewardRecodeId]) {
        Toast('超过领取时间，无法兑换');
        return;
      }
      this.winRewardGoods.appointmentFlag = item.appointmentFlag;
      this.awardObj = {};
      let extendConfig = JSON.parse(item.extendConfig) || {};
      if (item.extendConfigFlag && item.rewardType == 2) {
        extendConfig = JSON.parse(item.extendConfig);
        extendConfig.userName = item.rewardRecordextendConfigPrivacy.userName;
        extendConfig.userPhone = item.rewardRecordextendConfigPrivacy.userPhone;
        extendConfig.userAddress = item.rewardRecordextendConfigPrivacy.userAddress;
      }
      this.awardObj = Object.assign(extendConfig, item);
      if (this.awardObj.collectionType !== '4') {
        this.awardObj.drawOrderSource = null;
      }
      // 抽奖后展示下一级 || 抽奖机会为0展示下一级
      if ((this.hasNextActivityFlag && this.jumpNextPageType === '0') || (this.hasNextActivityFlag && this.jumpNextPageType === '1')) {
        this.awardObj.singleFlag = true;
      }
      this.awardObj.bigWheelActivityType = Number(this.bigWheelActivityType);
      if (item.rewardType === '1') {
        //虚拟
        // 免单流程
        // drawOrderSource 0:无;1:PC;2:APP;3:微信HI荣耀小程序;4:支付宝HI荣耀小程序
        if (item.drawOrderSource === '1' || item.drawOrderSource === '2') {
          item.isBeneficial = true;
        }
        if (['2', '3', '4'].includes(item.collectionType)) {
          //跳转预约导购
          this.$refs.virtualizedAwardModal.openModel({
            flag: this.miniType === '1' ? true : this.isGuideFlag,
            codeId: this.awardObj.exchangeActivationCodeId,
            type: item.collectionType,
            ...this.awardObj,
          }); //跳转hi荣耀预约创建不需要录入客户信息
        } else {
          //正常不跳转的
          // 如果有客户信息直接展示虚拟奖品弹框
          if (item.rewardRecordextendConfigPrivacy) {
            this.$refs.virtualAwardModal.openModel();
          } else {
            this.userInfoList = item.userInfoList || [];
            //没有展示虚拟客户需要录入信息的弹框
            this.$refs.virtualizedAwardModal.openModel();
          }
        }
      } else if (item.rewardType === '2') {
        //实物
        // 领取方式为（5：货柜自取）或（2：到店自提）
        if (['2', '5'].includes(item.collectionType)) {
          this.$refs.receiveAwardModal.openModel({
            flag: this.isGuideFlag,
            codeId: this.awardObj.exchangeActivationCodeId,
            type: item.collectionType,
            ...this.awardObj,
            // 打开弹窗方式，drawHandler：抽奖结果处理，viewRecord：查看我的中奖记录
            openSrc: 'viewRecord',
          }); //跳转hi荣耀预约创建不需要录入客户信息
        } else {
          this.$refs.kindAwardModal.openModel();
        }
      } else if (['3', '5'].includes(item.rewardType)) {
        //优惠券、代金券
        if (item.goodsPictureUrl) {
          let pic = JSON.parse(item.goodsPictureUrl);
          let imgItem = this.$utils.getImageUrl(pic.file);
          this.awardObj.imgItem = imgItem;
        }
        if (item.voucherStartDate && item.voucherEndDate) {
          this.awardObj.voucherStartDate = item.voucherStartDate;
          this.awardObj.voucherEndDate = item.voucherEndDate;
        }
        console.log('this.awardObj-', this.awardObj);
        this.$refs.couponModal.openModel();
      } else if (item.rewardType === '6') {
        // 赠品券
        this.awardObj.collectionType = '2';
        this.$refs.virtualizedAwardModal.openModel({
          flag: this.miniType === '1' ? true : this.isGuideFlag,
          codeId: this.awardObj.exchangeActivationCodeId,
          type: item.collectionType,
          ...this.awardObj,
        });
      }
    },
    //实物奖品录入完客户信息再打开实物奖品弹框
    openKindAwardModal() {
      this.$refs.kindAwardModal.openModel();
    },
    //虚拟奖品录入完客户信息再打开虚拟奖品弹框
    openVirtualAwardModal() {
      this.$refs.virtualAwardModal.openModel();
    },
    //判断大转盘活动是否有对应门店
    checkLottyChannel(activityCode, channelCode) {
      return new Promise((resolve, reject) => {
        let params = {
          activityCode: activityCode,
          channelCode: channelCode || sessionStorage.getItem('navChannelCode'),
        };
        this.$api.post({
          noLoading: true,
          sc: 'mobileMarketingH5',
          url: 'ArrangementActivity/checkBigWheelActivityByChannelCode',
          params,
          success: (r) => {
            resolve(r);
          },
        });
      });
    },
    //判断大转盘是否有抽奖次数
    checkLottyTimes() {
      let self = this;
      return new Promise((resolve, reject) => {
        let params = {
          userOpenid: self.loginType == 'wechat' ? self.userBase.openId || '' : '',
          userUnionid: self.loginType == 'wechat' ? self.userBase.unionid || '' : '',
          alipayUserId: self.loginType == 'Alipay' ? sessionStorage.getItem('alipayUserId') || '' : '',
          loginType: self.loginType || '',
          associationActivityCode: sessionStorage.getItem('associationActivityCode'),
        };
        this.$api.post({
          noLoading: true,
          sc: 'mobileMarketingH5',
          url: 'ArrangementActivity/checkBigWheelActivityByTimes',
          params,
          success: (r) => {
            resolve(r);
          },
        });
      });
    },
    // 抽奖事件
    async pointer(boxIndex) {
      if (this.loginType === 'wechat' && !this.isLoginFlag) {
        wx.miniProgram.postMessage({
          h5LoginToMiniFlag: !this.isLoginFlag || true,
        });
        if (this.activityTypeFlag == '1') {
          wx.miniProgram.reLaunch({
            url: '/pages/tabBar/index/index?activityUrl=' + encodeURIComponent(this.activityUrl),
            success: function () {
              console.log('跳转回小程序的页面success');
            },
            fail: function (res) {
              console.log('跳转回小程序的页面fail', res);
            },
          });
        } else if (this.activityTypeFlag == '2') {
          wx.miniProgram.reLaunch({
            url: '/pages/index?activityUrl=' + encodeURIComponent(this.activityUrl),
            success: function () {
              console.log('跳转回小程序的页面success');
            },
            fail: function (res) {
              console.log('跳转回小程序的页面fail', res);
            },
          });
        }
        return;
      }
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      const self = this;
      // 活动被引用且存在联合活动编码时（活动编排场景）
      if (this.activityObj.isUsed === '1' && sessionStorage.getItem('associationActivityCode')) {
        const res = await this.checkLottyTimes();
        if (!res.result) {
          Dialog.alert({
            title: '提示',
            message: '您已达到本次抽奖活动的最大抽奖次数,感谢您的支持！',
          }).then(() => {
            if (self.hasNextActivityFlag) {
              self.nextStep();
            }
          });
          return;
        }
      }
      console.log('pointer里的this.drawWheelType', this.drawWheelType);
      console.log('pointer里的this.bigWheelActivityType', this.bigWheelActivityType);
      console.log('pointer里的this.drawResultsMessage', this.drawResultsMessage);
      console.log('pointer里的this.miniprogramFlag', this.miniprogramFlag);
      console.log('pointer里的this.loginType', this.loginType);
      // 如果用户未永久选择订阅推送消息 （定时开奖盲盒活动 并且微信登陆、在小程序环境里打开、用户首次抽奖），则跳转小程序页面拉起订阅通知
      if (
        this.drawWheelType == '3' &&
        ['2', '4'].includes(this.bigWheelActivityType) &&
        this.drawResultsMessage === false &&
        this.miniprogramFlag &&
        this.loginType == 'wechat' &&
        !this.whetherActivity
      ) {
        console.log('进了订阅消息条件判断了！！！');
        wx.miniProgram.navigateTo({
          url: `/subpackages/activity/pages/activityH5Notify/activity-h5-notify?bigWheelActivityType=${this.bigWheelActivityType}`,
        });
      }
      // 大转盘正在旋转，直接返回，不能进行抽奖
      if (this.turnplate.bRotate && this.bigWheelActivityType != '4') return;
      // 抽奖中标识设置
      this.turnplate.bRotate = !this.turnplate.bRotate;
      if (this.bigWheelActivityType === '1') {
        //让转盘先转起来
        $('#wheelcanvas').rotate({
          angle: 0,
          animateTo: 5400,
          duration: 15000,
        });
      }
      // 用户性别
      let userGender = '';
      if (self.userBase.sex === 1 || self.userBase.gender === 'm') {
        userGender = '1';
      } else if (self.userBase.sex === 2 || self.userBase.gender === 'f') {
        userGender = '2';
      }
      // 头像
      const headimgurl = self.loginType == 'wechat' ? self.userBase.headimgurl : self.userBase.avatar;
      // 抽奖接口入参
      const params = {
        activityCode: self.drawCode || self.activityObj.activityCode,
        openId: self.loginType === 'wechat' ? self.userBase.openId || '' : '',
        unionid: self.loginType === 'wechat' ? self.userBase.unionid || '' : '',
        alipayUserId: self.loginType == 'Alipay' ? sessionStorage.getItem('alipayUserId') || '' : '',
        loginType: self.loginType || '',
        loginSide: self.loginType === LoginType.Wechat ? 'wxapp' : self.loginType === LoginType.Alipay ? 'alipaymini' : '',
        drawType: self.drawType,
        referrFlag: self.userBase.referrFlag ? self.userBase.referrFlag : 0,
        nickName: self.userBase.nickName || self.userBase.accountNo || '',
        sex: userGender,
        headimgurl: headimgurl,
      };
      params.memberCode = this.memberInfo.memberCenterId;
      // 支付宝场景处理逻辑
      if (!sessionStorage.getItem('alipayUserId')) {
        // 支付宝已经是隐私结构体了
        const privacyKeys = {
          nickName: '$PrivacyPlain$',
        };
        //隐私信息保存
        const privacyKeyLsit = [
          {
            nickName: 'nickName',
            typeText: 'NAME',
            labelText: 'nick_name',
          },
        ];
        self.$utils.privacySave(privacyKeys, privacyKeyLsit, params);
      }
      if (
        !self.drawCode &&
        this.activityObj.isUsed === '1' &&
        this.activityObj.channelFlag === '2' &&
        sessionStorage.getItem('associationActivityCode') &&
        sessionStorage.getItem('navChannelCode') &&
        self.activityObj.activityUrlTypel === '1'
      ) {
        params.activityCode = `${self.activityObj.activityCode}_${sessionStorage.getItem('navChannelCode')}`;
      }
      // 进行抽奖，并查询接口
      self.$api.post({
        noLoading: true,
        sc: 'mobileMarketing',
        url: 'h5/bigWheel/getWinRewardGoods',
        params: params,
        success: (r) => {
          Toast.clear();
          if (this.bigWheelActivityType == '4') {
            this.getLotty();
          }
          if (r.code === 500) {
            this.activityStatus = '2';
            Dialog.alert({
              title: '提示',
              message: r.message,
            });
          }
          if (r && r.result) {
            const result = r.result.bigWheelRewards;
            this.userInfoList = r.result.userInfoList || [];
            this.winRewardGoods = r.result;
            this.activityStatus = r.result.activityStatus;
            // otherDraw => 额外抽奖次数，true：当前额外抽奖次数为0
            if (r.result.otherDraw) {
              if (this.userBase.member) {
                self.getChance();
              } else {
                this.pointDrawFlag = true;
              }
              if (this.bigWheelActivityType == '1') {
                $('#wheelcanvas').stopRotate();
              }
              self.$utils.tips.message('warning', r.result.message);
              return;
            }
            // 抽奖结果信息返回不为空，说明抽奖成功
            if (result) {
              if (this.tigerLottery) {
                // 老虎机开始抽奖
                this.$refs.tigerMachineDraw.drawLottery();
              }
              //不需要核销跳预约导购页面的collectionType得手动赋值1
              //虚拟||实物 && 如果id没值（代表正常的 1:邮寄(实物)/线上兑换(虚拟))
              if ([1, 2].includes(result.goodsType) && !result.id) {
                result.collectionType = 1;
              }
              // 如果为盲盒抽奖
              if (this.bigWheelActivityType == '2') {
                this.boxIndex = boxIndex;
                setTimeout(() => {
                  this.boxIndex = '';
                  this.rotateFn(result);
                  // 埋码事件：抽奖结果
                  this.handleClickResultAwardRotateProcess(result);
                  if (this.userBase.member) {
                    this.getChance();
                  } else {
                    this.pointDrawFlag = true;
                  }
                }, 500);
              } else if (this.bigWheelActivityType == '4') {
                this.handleClickResultAwardRotateProcess(result);
                this.showEndPage = true;
                this.getChance();
              } else {
                // 大转盘抽奖
                this.rotateFn(result);
                // 埋码事件：抽奖结果
                this.handleClickResultAwardRotateProcess(result);
                if (this.userBase.member) {
                  this.getChance();
                } else {
                  this.pointDrawFlag = true;
                }
              }
            } else {
              if (this.activityStatus == '3') {
                this.$utils.tips.message('warning', '当前活动已结束！');
              } else if (this.activityStatus == '1' && !r.result.flag) {
                // 活动进行中 用户不可以抽奖
                this.canDrawFlag = false;
                this.participateTimes = 0;
                this.noChance();
              } else if (this.activityStatus == '2') {
                this.hasStop();
              }
            }
          }
        },
        failure: (err) => {
          Toast.clear();
          if (this.bigWheelActivityType == '1') {
            $('#wheelcanvas').stopRotate();
          }
          Dialog.alert({
            title: '提示',
            message: '活动过于火爆，请稍后再试',
          });
          self.turnplate.bRotate = !self.turnplate.bRotate;
        },
      });
      console.log('awardRoatate-pointer-activityStatus', this.activityStatus);
    },
    rotateFn(obj) {
      const self = this;
      let index = 0;
      let exitFlag = false;
      const bigWheelRewardList = self.bigWheelRewardList;
      const len = bigWheelRewardList.length;
      for (let i = 0; i < len; i++) {
        // 根据奖品ID与奖品池ID进行对比
        if (obj.id === bigWheelRewardList[i].id) {
          index = i;
          exitFlag = true;
          break;
        }
      }
      // 当前中奖物品未能匹配到奖品池物品
      if (!exitFlag) {
        self.$utils.tips.message('warning', '奖项配置发生变化，请刷新页面后重试！');
        return false;
      }
      if (this.tigerLottery) {
        // 老虎机抽奖结果展示
        this.$refs.tigerMachineDraw.displayDrawResult(index, obj);
        return;
      }
      // 大转盘停留位置控制
      const item = index + 1;
      let angles = item * (360 / this.turnplate.restaraunts.length) - 360 / (this.turnplate.restaraunts.length * 2);
      if (angles < 270) {
        angles = 270 - angles;
      } else {
        angles = 360 - angles + 270;
      }
      this.$nextTick(() => {
        if (this.bigWheelActivityType == '1') {
          $('#wheelcanvas').stopRotate();
          $('#wheelcanvas').rotate({
            angle: 0,
            animateTo: angles + 1800,
            duration: 5000,
            callback: function () {
              self.handleAwardWinning(obj, index);
            },
          });
        } else if (this.bigWheelActivityType === '2') {
          self.handleAwardWinning(obj, index);
        }
      });
    },
    // 老虎机中奖结果处理
    tigerMachineWinningHandler(param) {
      this.handleAwardWinning(param.awardObj, param.awardIndex);
    },
    // 中奖处理
    handleAwardWinning(obj, index) {
      // goodsType ,0未中奖 1虚拟 2实物 3优惠券 4积分 5代金券 6赠品券
      // collectionType 领取类型(1:邮寄(实物)/线上兑换(虚拟);2:到店自提(实物)/线下核销(虚拟);3:线下核销发串码(虚拟)) 4:免单抽奖
      //跳转预约导购：（实物||虚拟）&& （2 || 3）
      //未中奖

      this.awardObj = this.bigWheelRewardList[index];
      this.awardObj.bigWheelActivityType = Number(this.bigWheelActivityType);
      this.awardObj.effectiveStartTime = this.winRewardGoods.effectiveStartTime;
      this.awardObj.effectiveEndTime = this.winRewardGoods.effectiveEndTime;
      this.awardObj.appointmentFlag = this.winRewardGoods.appointmentFlag;
      // 实物奖品，货柜自提领取方式涉及字段
      this.awardObj.rewardType = this.winRewardGoods.bigWheelRewards.goodsType;
      this.awardObj.pickUpCode = this.winRewardGoods.bigWheelRewards.pickUpCode;
      this.awardObj.inventoryFlag = this.winRewardGoods.inventoryFlag;
      this.awardObj.userQrCode = this.winRewardGoods.userQrCode;
      this.awardObj.channelName = this.winRewardGoods.channelName;
      this.awardObj.jumpType = this.winRewardGoods.bigWheelRewards.jumpType;
      this.awardObj.jumpUrl = this.winRewardGoods.bigWheelRewards.jumpUrl;
      if (this.awardObj.collectionType !== '4') {
        this.awardObj.drawOrderSource = null;
      }
      // 未中奖
      if (obj.goodsType == '0' && obj.goodsType) {
        if (!this.regularDrawShowStatus || (this.regularDrawShowStatus && (this.regularDrawShowStatus == '1' || this.regularDrawShowStatus == '2'))) {
          this.$refs.noAwardModal.openModel();
        } else {
          this.getLotty();
        }
      }
      // 虚拟中奖
      else if (obj.goodsType == '1' && obj.goodsType) {
        if (['2', '3', '4'].includes(obj.collectionType)) {
          //虚拟
          //小程序类型 1 => 体验店  2 => 直营店
          this.$refs.virtualizedAwardModal.openModel({
            flag: this.miniType === '1' ? true : this.isGuideFlag,
            codeId: obj.activationCodeId,
            type: obj.collectionType,
            ...this.awardObj,
            ...obj,
          });
        } else {
          this.$refs.virtualizedAwardModal.openModel({
            flag: false,
          });
        }
      }
      // 实物中奖
      else if (obj.goodsType == '2' && obj.goodsType) {
        //实物
        if (['2', '5'].includes(obj.collectionType)) {
          this.$refs.receiveAwardModal.openModel({
            flag: this.isGuideFlag,
            codeId: obj.activationCodeId,
            type: obj.collectionType,
            // 打开弹窗方式，drawHandler：抽奖结果处理，viewRecord：查看我的中奖记录
            openSrc: 'drawHandler',
          }); //跳转hi荣耀预约创建不需要录入客户信息
        } else {
          this.$refs.receiveAwardModal.openModel({
            flag: false,
          });
        }
      }
      // 优惠券、代金券 中奖
      else if (['3', '5'].includes(obj.goodsType) && obj.goodsType) {
        console.log('------------this.awardObj---------', this.awardObj);
        if (obj.goodsType == '5') {
          //代金券中奖涉及字段 代金券生效时间、跳转活动
          this.awardObj.voucherStartDate = this.winRewardGoods.bigWheelRewards.voucherStartDate;
          this.awardObj.voucherEndDate = this.winRewardGoods.bigWheelRewards.voucherEndDate;
        }
        this.$refs.couponModal.openModel();
      }
      // 积分中奖
      else if (obj.goodsType == '4' && obj.goodsType) {
        this.$refs.pointModal.openModel();
      }
      // 赠品券中奖
      else if (obj.goodsType === '6' && obj.goodsType) {
        this.awardObj.collectionType = '2';
        this.$refs.virtualizedAwardModal.openModel({
          flag: true,
          codeId: obj.activationCodeId,
          type: obj.collectionType,
          ...this.awardObj,
          ...obj,
        });
      }
      this.getRecord();
      this.awardObj = this.bigWheelRewardList[index];
      this.awardObj.recordId = obj.recordId;
      this.awardObj.activationCode = obj.activationCode;
      if (['3', '5'].includes(obj.goodsType) && obj.goodsType) {
        const pic = JSON.parse(obj.goodsPictureUrl);
        const imgItem = this.$utils.getImageUrl(pic.file);
        this.awardObj.imgItem = imgItem;
      }
      if (
        (this.hasNextActivityFlag && this.jumpNextPageType === '0') ||
        (!this.participateTimes && this.hasNextActivityFlag && this.jumpNextPageType === '1')
      ) {
        this.awardObj.singleFlag = true;
      }
      this.turnplate.bRotate = !this.turnplate.bRotate;
    },
    // 定时抽奖 增加抽奖按钮 点击去抽奖
    goLottery() {
      if (this.loginType === 'wechat' && !this.isLoginFlag) {
        wx.miniProgram.postMessage({
          h5LoginToMiniFlag: !this.isLoginFlag || true,
        });
        if (this.activityTypeFlag == '1') {
          wx.miniProgram.reLaunch({
            url: '/pages/tabBar/index/index?activityUrl=' + encodeURIComponent(this.activityUrl),
            success: function () {
              console.log('跳转回小程序的页面success');
            },
            fail: function (res) {
              console.log('跳转回小程序的页面fail', res);
            },
          });
        } else if (this.activityTypeFlag == '2') {
          wx.miniProgram.reLaunch({
            url: '/pages/index?activityUrl=' + encodeURIComponent(this.activityUrl),
            success: function () {
              console.log('跳转回小程序的页面success');
            },
            fail: function (res) {
              console.log('跳转回小程序的页面fail', res);
            },
          });
        }
        return;
      }
      console.log('goLottery里的this.canDrawFlag', this.canDrawFlag);
      if (this.canDrawFlag && this.activityStatus == '1') {
        this.pointer('');
      } else {
        if (this.activityStatus == '3') {
          // 活动结束提示
          this.hasEnd();
          return;
        }
        this.noChance();
      }
    },
    noChance() {
      if (this.userBase.userType === '3') {
        if (this.communityUserStatus === 0) {
          Dialog.alert({
            message: '您未加入会员群，加入后获得抽奖机会',
          });
          return;
        } else if (this.communityUserStatus === 2) {
          Dialog.alert({
            message: '您不是新用户，无法参与该活动',
          });
          return;
        }
      }
      this.$utils.tips.message('warning', '抽奖机会已用完');
    },
    noPoints() {
      this.$utils.tips.message('warning', `${this.poinsOrDiamonds}不足`);
    },
    notStart() {
      this.$utils.tips.message('warning', '活动未开始！');
    },
    hasEnd() {
      this.$utils.tips.message('warning', '活动已结束！');
    },
    hasStop() {
      this.$utils.tips.message('warning', '活动已暂停！');
    },
    // jumpType '按钮跳转配置类型: 0小程序代金券列表;1小程序首页;2自定义链接;3入会好礼各奖品默认页面;4小程序优惠券列表;9无跳转',
    nextStep(link, type) {
      // type=1，跳转到小程序首页
      if (type === '1') {
        if (this.miniprogramFlag) {
          // 微信
          if (this.loginType === 'wechat') {
            wx.miniProgram.switchTab({
              url: '/pages/tabBar/index/index',
              success: function () {
                console.log('跳转回小程序的页面success');
              },
              fail: function (res) {
                console.log('跳转回小程序的页面fail', res);
              },
            });
            // 支付宝
          } else {
            my.switchTab({
              url: '/pages/tabBar/index/index',
            });
          }
        } else {
          //在支付宝内部浏览器打开
          window.location.href = 'alipays://platformapi/startapp?appId=2021002121684220&page=pages/tabBar/index/index';
        }
      }
      //type=2，自定义链接
      if (link && type === '2') {
        if (link.indexOf('http') > -1 && link.indexOf('webViewSrc') === -1) {
          // H5链接(可能是活动、第三方链接)
          if (link.indexOf('hdmain') > -1) {
            console.log('跳转hd活动=====》');
            const path = '/hdmain?' + link.split('?')[1];
            this.$router.push({
              path: path,
            });
            this.$store.commit('base/setIsRouterAlive', false);
            this.$nextTick(() => this.$store.commit('base/setIsRouterAlive', true));
          } else {
            console.log('其他链接=====》');
            window.location.href = link;
          }
        } else {
          // 小程序链接 (小程序页面、活动)
          let usePath = link;
          if (link.indexOf('webViewSrc') > -1) {
            const goUrl = encodeURIComponent(link);
            usePath = `/pages/webView/activity-web-view?webViewSrc=${goUrl}`;
          }
          if (this.miniprogramFlag) {
            if (this.loginType === 'wechat') {
              //在微信小程序内部打开
              link.startsWith('/pages/tabBar') &&
                wx.miniProgram.switchTab({
                  url: link,
                });
              !link.startsWith('/pages/tabBar') &&
                wx.miniProgram.navigateTo({
                  url: usePath,
                  success: function () {
                    console.log('跳转回小程序的页面success');
                  },
                  fail: function (res) {
                    console.log('跳转回小程序的页面fail', res);
                  },
                });
            } else {
              // 在支付宝小程序内部打开
              link.startsWith('/pages/tabBar') &&
                my.switchTab({
                  url: link,
                });
              !link.startsWith('/pages/tabBar') &&
                my.redirectTo({
                  url: usePath,
                  success: function () {
                    console.log('跳转回小程序的页面success');
                  },
                  fail: function (res) {
                    console.log('跳转回小程序的页面fail', res);
                  },
                });
            }
          } else {
            // 小程序活动页面
            if (link.indexOf('webViewSrc') > -1) {
              let usePath = link;
              const goUrl = encodeURIComponent(link);
              usePath = `pages/webView/activity-web-view?webViewSrc=${goUrl}`;
              const url = `alipays://platformapi/startapp?appId=2021002121684220&page=${usePath}`;
              window.location.href = url;
              // H5页面
            } else {
              const linkArr = link.split('?');
              window.location.href = 'alipays://platformapi/startapp?appId=2021002121684220&page=' + linkArr[0] + '&query=' + linkArr[1];
            }
          }
        }
      }
      // type=4，优惠券
      if (type === '4') {
        if (this.miniprogramFlag) {
          if (this.loginType === 'wechat') {
            wx.miniProgram.navigateTo({
              url: `/subpackages/my/pages/couponList/coupon-list?couponType=0`,
              success: function () {
                console.log('跳转回小程序的页面success');
              },
              fail: function (res) {
                console.log('跳转回小程序的页面fail', res);
              },
            });
          } else if (this.loginType === 'Alipay') {
            my.redirectTo({
              url: '/subpackages/my/pages/couponList/coupon-list?couponType=0',
            });
          }
        } else {
          window.location.href = 'alipays://platformapi/startapp?appId=2021002121684220&page=subpackages/my/pages/couponList/coupon-list';
        }
      }
      // type=0,代金券，不涉及支付宝
      if (type === '0') {
        if (this.loginType === 'wechat') {
          wx.miniProgram.navigateTo({
            url: `/subpackages/my/pages/couponList/coupon-list?couponType=1`,
            success: function () {
              console.log('跳转回小程序的页面success');
            },
            fail: function (res) {
              console.log('跳转回小程序的页面fail', res);
            },
          });
        }
      }
    },
    // 绘制转盘
    drawRouletteWheel() {
      const self = this;
      const canvas = document.getElementById('wheelcanvas');
      if (canvas.getContext) {
        console.log('self.turnplate', self.turnplate);
        //根据奖品个数计算圆周角度
        const arc = Math.PI / (self.turnplate.restaraunts.length / 2);
        const ctx = canvas.getContext('2d');
        ctx.scale(4, 4);
        //在给定矩形内清空一个矩形
        ctx.clearRect(0, 0, 422, 422);
        //strokeStyle 属性设置或返回用于笔触的颜色、渐变或模式
        ctx.strokeStyle = 'rgba(0,0,0,0)';
        //font 属性设置或返回画布上文本内容的当前字体属性
        ctx.font = '16px Microsoft YaHei';
        for (let i = 0; i < self.turnplate.restaraunts.length; i++) {
          const angle = self.turnplate.startAngle + i * arc;
          ctx.fillStyle = self.turnplate.colors[i];
          ctx.beginPath();
          //arc(x,y,r,起始角,结束角,绘制方向) 方法创建弧/曲线（用于创建圆或部分圆）
          ctx.arc(211, 211, self.turnplate.outsideRadius, angle, angle + arc, false);
          ctx.arc(211, 211, self.turnplate.insideRadius, angle + arc, angle, true);
          ctx.stroke();
          ctx.fill();
          //锁画布(为了保存之前的画布状态)
          ctx.save();

          //----绘制奖品开始----
          ctx.fillStyle = '#E5302F';
          //translate方法重新映射画布上的 (0,0) 位置
          ctx.translate(211 + Math.cos(angle + arc / 2) * self.turnplate.textRadius, 211 + Math.sin(angle + arc / 2) * self.turnplate.textRadius);

          //rotate方法旋转当前的绘图
          ctx.rotate(angle + arc / 2 + Math.PI / 2);

          /** 下面代码根据奖品类型、奖品名称长度渲染不同效果，如字体、颜色、图片效果。(具体根据实际情况改变) **/
          // var img = new Image();
          // img.src = self.turnplate.imgs[i];
          // img.onload = function(){
          //     console.log('img' + i);
          //     console.log(img.src);
          //     console.log('width: ' + img.width);
          //     ctx.drawImage(img,-50,-20,100,100);
          // }(i)

          const imgObj = document.getElementById('img' + i);
          imgObj.onload = (function () {
            ctx.drawImage(imgObj, -40, -10, 80, 80);
          })(i);
          // ctx.drawImage(img,-50,-20,100,100);

          //把当前画布返回（调整）到上一个save()状态之前
          ctx.restore();
          //----绘制奖品结束----
        }
      }
    },
    // 跳转直营店小程序
    goBrandStoreMiniProgram(page) {
      if (this.loginType === 'wechat' && !this.isLoginFlag) {
        wx.miniProgram.postMessage({
          h5LoginToMiniFlag: !this.isLoginFlag || true,
        });
        if (this.activityTypeFlag == '2') {
          wx.miniProgram.reLaunch({
            url: '/pages/index?activityUrl=' + encodeURIComponent(this.activityUrl),
            success: function () {
              console.log('跳转回小程序的页面success');
            },
            fail: function (res) {
              console.log('跳转回小程序的页面fail', res);
            },
          });
        }
        return;
      }
      // 跳转到我的奖品页
      if (page === 'rewardQuery') {
        wx.miniProgram.navigateTo({
          url: '/pageMyCenter/rewardQuery/rewardQuery',
        });
      }
    },
    // 跳转 Hi荣耀 小程序
    goHiHonorMiniProgram(type) {
      if (this.loginType == 'wechat') {
        //在微信小程序环境打开
        if (type === 'index') {
          wx.miniProgram.postMessage({
            activityUrl: encodeURIComponent(this.activityUrl),
          });
          if (this.miniType === '1') {
            wx.miniProgram.reLaunch({
              url: '/pages/tabBar/index/index?activityUrl=' + encodeURIComponent(this.activityUrl),
            });
          } else {
            wx.miniProgram.reLaunch({
              url: '/pages/index?activityUrl=' + encodeURIComponent(this.activityUrl),
            });
          }
        } else if (type === 'my') {
          wx.miniProgram.switchTab({
            url: '/pages/tabBar/my/my',
          });
        } else if (type === 'rewardQuery') {
          let url = '/subpackages/my/pages/rewardQuery/reward-query';
          console.log('用户信息userBase');
          console.log(this.userBase);
          if (this.loginType === 'wechat' && !this.isLoginFlag) {
            wx.miniProgram.postMessage({
              h5LoginToMiniFlag: !this.isLoginFlag || true,
            });
            if (this.activityTypeFlag == '1') {
              wx.miniProgram.switchTab({
                url: '/pages/tabBar/index/index?activityUrl=' + encodeURIComponent(this.activityUrl),
                success: function () {
                  console.log('跳转回小程序的页面success');
                },
                fail: function (res) {
                  console.log('跳转回小程序的页面fail', res);
                },
              });
            }
            return;
          }
          if (!this.userBase) {
            url += '?refresh=1';
          } else if (!this.userBase.member) {
            url += '?refresh=1';
          }
          wx.miniProgram.navigateTo({
            url: url,
          });
        }
      } else if (this.loginType == 'Alipay') {
        //在支付宝小程序环境打开
        if (this.miniprogramFlag) {
          if (type === 'index') {
            // 网页向小程序 postMessage 消息
            my.postMessage({
              activityUrl: encodeURIComponent(this.activityUrl),
            });
            my.switchTab({
              url: '/pages/tabBar/index/index?activityUrl=' + encodeURIComponent(this.activityUrl),
            });
          } else if (type === 'rewardQuery') {
            my.redirectTo({
              url: '/subpackages/my/pages/rewardQuery/reward-query',
            });
          }
        } else {
          //在支付宝内部浏览器打开
          if (type === 'index') {
            const query = encodeURIComponent(`activityUrl=${this.activityUrl}`);
            window.location.href = 'alipays://platformapi/startapp?appId=2021002121684220&page=pages/tabBar/index/index&query=' + query;
          } else if (type === 'rewardQuery') {
            let url = 'alipays://platformapi/startapp?appId=2021002121684220&page=subpackages/my/pages/rewardQuery/reward-query';
            console.log('用户信息userBase');
            console.log(this.userBase);
            if (!this.userBase) {
              url += '?refresh=1';
            } else if (!this.userBase.member) {
              url += '?refresh=1';
            }
            window.location.href = url;
          }
        }
      }
    },

    // 如果不在当前页面小程序中，则配置微信参数
    wxConfig() {
      let param = window.location.href;
      this.$api.post({
        noLoading: true,
        sc: 'mobileMarketingH5',
        url: `getShareParams?url=${encodeURIComponent(param)}`,
        success: (r) => {
          let result = r.result || {};
          let appId = result.appId;
          let timestamp = result.timestamp;
          let nonceStr = result.nonceStr;
          let signature = result.signature;
          wx.config({
            debug: false,
            appId: appId,
            timestamp: timestamp,
            nonceStr: nonceStr,
            signature: signature,
            jsApiList: [''],
            openTagList: ['wx-open-launch-weapp', 'wx-open-subscribe'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
          });
        },
      });
    },
    // 滚动栏动画
    horseRaceLamp(id) {
      const area = document.getElementById(id);
      const lHeight = 60;
      const time = 50;
      // 滚动停留时间
      const scrollStaySeconds = this.activityObj.scrollStaySeconds ? this.activityObj.scrollStaySeconds * 1000 : 0;

      area.innerHTML += area.innerHTML;
      area.style.top = '0px';
      const scrollHeight = area.scrollHeight;
      // 移动速度
      const scrollMove = () => {
        area.style.top = parseInt(area.style.top) - 3 + 'px';
        this.timeInterval = setInterval(scrollUp, time);
      };
      const scrollUp = () => {
        if (parseInt(area.style.top) % lHeight == 0) {
          clearInterval(this.timeInterval);
          this.timeTimeout = setTimeout(scrollMove, scrollStaySeconds);
        } else {
          area.style.top = parseInt(area.style.top) - 3 + 'px';
          if (Math.abs(parseInt(area.style.top)) >= scrollHeight / 2) {
            //判断滚动高度,当滚动高度大于area本身的高度时，使其回到原点重新滚动
            area.style.top = '0px';
          }
        }
      };
      scrollMove();
    },

    // 判断是否在小程序内
    handleMiniprogramJudge() {
      const that = this;
      if (this.loginType == 'wechat') {
        //判断是否在微信小程序环境
        wx.miniProgram.getEnv(function (res) {
          console.log('微信环境下', res);
          if (res.miniprogram) {
            that.miniprogramFlag = res.miniprogram;
          }
        });
      } else if (this.loginType == 'Alipay') {
        loadAlipayWebViewScript().then((res) => {
          console.log('支付宝环境下', res);
          if (res) {
            //判断是否运行在支付宝小程序环境里
            my.getEnv(function (res) {
              if (res.miniprogram) {
                that.miniprogramFlag = res.miniprogram;
              }
            });
          }
        });
      }
    },
    closeEnd(data) {
      this.showEndPage = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.awardRotate {
  width: 100%;
  height: 100%;
  max-width: 480px;
  margin: 0px auto;
  background: #5f9dff;
}
.bottom-text {
  font-family: HYQiHei-EZS;
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  font-weight: 400;
  padding: 10px;
}

.section-two {
  .member-login-area {
    font-family: HYQiHei-EES;
    font-size: 16px;
    padding: 5px 10px;
    border-radius: 30px;
    background: #fff;
    margin: 20px 0px 20px 0px;
    width: 200px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    font-weight: 400;
    text-align: center;
    .member-login-text {
      background-clip: text;
      -webkit-background-clip: text;
      text-fill-color: transparent;
      -webkit-text-fill-color: transparent;
    }
  }
  .btn-area {
    width: 85px;
    height: 24px;
    border: 1px solid #ffffff;
    border-radius: 12px;
    font-size: 13px;
    color: #ffffff;
    text-align: center;
    padding: 3px 5px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .tiger-my-award {
    display: inline-block;
    margin-left: 20px;
  }
  .tiger-award-list {
    float: right;
    display: inline-block;
    margin-right: 20px;
  }
}
.section-three {
  padding: 10px 0 10px;
}
ul,
ol {
  list-style-type: none;
}

select,
input,
img,
select {
  vertical-align: middle;
}

input {
  font-size: 12px;
}

a {
  text-decoration: none;
  color: #000;
}

a:hover {
  color: #c00;
  text-decoration: none;
}

.clear {
  clear: both;
}

/* 大转盘样式 */
.banner {
  display: block;
  width: 95%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
}

.activity-rules {
  display: block;
  width: 95%;
  margin-left: auto;
  margin-right: auto;
}
.banner .turnplate {
  margin-top: 20px;
  overflow: hidden;
  display: block;
  width: 100%;
  position: relative;
}

.banner .turnplate canvas.item {
  width: 100%;
}

.banner .turnplate .pointer,
.member-login {
  position: absolute;
  width: 32%;
  height: 39.07%;
  left: 34.3%;
  top: 26%;
  font-size: 14px;
  color: #fff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.banner .turnplate .pointer img,
.member-login img {
  width: 100%;
}

.pointer .text-wrap,
.member-login .text-wrap {
  position: absolute;
  left: 50%;
  top: 57%;
  transform: translate(-50%, -50%);
  width: 100%;
}

.listBar {
  height: 16px;
  border-radius: 8px;
  background: #0c69f5;
}

.list-wrap .container {
  background: #fff;
  border-radius: 10px;
  width: 96%;
  margin: 0 2%;
  /* margin-top: -8px; */
  padding: 20px 10px 20px;
  position: relative;
}

.list {
  margin-top: 15px;
  font-size: 14px;
  max-height: 180px;
  overflow: hidden;
}

.list ul {
  width: 110%;
  padding-right: 10%;
}

.list li {
  display: flex;
  line-height: 36px;
}

.listItemLeft {
  width: 80px;
}

.listItemRight {
  width: 60px;
  text-align: end;
}

.listItemCenter {
  text-align: center;
  flex: 1;

  span {
    text-align: center;
  }
}

.leftBall,
.rightBall {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #5f9dff;
  position: absolute;
  bottom: -5px;
}

.leftBall {
  left: -5px;
}

.rightBall {
  right: -5px;
}

.ruleWrapper {
  margin-top: 15px;
  font-size: 14px;
  display: flex;
  flex-wrap: wrap;
  .ruleImg /deep/ img {
    width: 100px;
    height: 100px;
    margin-right: 5px;
  }
  .ruleImg /deep/ a {
    color: #2d8cf0 !important;
  }
}

.actionBtn {
  color: #2592f7;
  border: 1px solid #2592f7;
  text-align: center;
  line-height: 28px;
  padding: 2px 10px 1px;
  border-radius: 15px;
  font-size: 12px;
}

.nextStep {
  background-image: linear-gradient(131deg, #f9ca3d 0%, #f89659 30%, #f86f6f 100%);
  box-shadow: 0 2px 6px 0 #f4460a;
  border-radius: 100px;
  border-radius: 72px;
  width: 90%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  position: absolute;
}

.nextActivity {
  width: 80px;
  background: transparent;
  border: 1px solid #fff;
  right: 15px;
  top: -30px;
  box-shadow: none;
  height: 30px;
  line-height: 30px;
}

.noList {
  height: 112px;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  color: #424241;
  font-size: 16px;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.myPoints {
  line-height: 30px;
  color: #fff;
  font-size: 14px;
}

.xcx-back-btn {
  position: absolute;
  right: 0px;
  bottom: 100px;
  width: 130px;
  z-index: 99999;
}
.tiger-btn-area {
  margin-top: 20px;
}
.awardRotateDisc {
  position: relative;
  padding-bottom: 20px;
}

.winnerBtn,
.myAwardBtn {
  width: 85px;
  height: 24px;
  border: 1px solid #ffffff;
  border-radius: 12px;
  position: absolute;
  bottom: -6px;
  right: 2.5%;
  font-size: 13px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.myAwardBtn {
  left: 2.5%;

  div:nth-child(1),
  div:nth-child(2) {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
  }
}

.award-list {
  width: 100%;
  margin: auto 0;
  pointer-events: none;
  scrollbar-width: none;
  /* firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .award-list-item {
    width: 100%;
    padding: 10px 10px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    pointer-events: none;

    .award-list-item-options {
      font-size: 14px;
      pointer-events: none;
      margin-right: 10px;
      line-height: 42px;

      img {
        display: inline;
        width: 42px;
        height: 42px;
        border-radius: 50%;
        margin-right: 5px;
      }

      div {
        display: inline;
        white-space: nowrap;
      }
    }

    .award-list-item-options:nth-child(1) {
      max-width: 40%;
      display: flex;
    }

    .award-list-item-options:nth-child(2) {
      text-align: center;
      width: 40%;
    }

    .award-list-item-options:nth-child(3) {
      min-width: 80px;
      margin-right: 0;
      text-align: right;
    }
  }
}

.member-tips-login {
  font-size: 18px;
  padding: 15px 30px;
  border-radius: 30px;
  background: #fff;
  display: inline-block;
  margin: 20px auto;
  line-height: 1;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 500;

  .member-tips-login-text {
    background-clip: text;
    -webkit-background-clip: text;
    text-fill-color: transparent;
    -webkit-text-fill-color: transparent;
  }
}

.member-login-btn {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.member-style {
  width: 91.2%;
  margin: 0 auto 10px;
  border-radius: 10px;
  overflow: hidden;

  .member-info {
    background: #ffffff92;
    width: 100%;
    height: 30px;
    padding: 20px 10px 20px;
    font-size: 14px;
    color: #000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tiger-member-info-nickname {
      margin-top: 20px;
      margin-left: 10px;
      padding-bottom: 15px;
    }
    .tiger-member-info-points {
      margin-top: 20px;
      margin-right: 10px;
      padding-bottom: 15px;
    }
    div {
      width: 50%;
      text-align: left;

      span {
        font-size: 16px;
        color: #ff6b22;
      }
    }

    div:nth-child(2) {
      text-align: right;
    }
    .points {
      width: 300px;
    }
  }

  .winning-info {
    background: #fff;
    padding: 20px 10px 20px;
    position: relative;
  }
}

.blindBox-main {
  width: 100vw;
  max-width: 480px;
  margin-left: -2.5%;
  position: relative;

  .blindBox-box,
  .blindBox-mask {
    width: 49%;
    height: 35%;
    position: absolute;
    top: 24%;
    left: 50%;
    transform: translate(-50%, 0);
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    img {
      width: 23%;
      height: initial;
      margin-right: 15.5%;

      &:nth-child(3n) {
        margin: 0;
      }
    }

    .blindBox-anima {
      animation: blindBoxAnimation 0.6s linear;
    }
  }
}

.blindBox-chance {
  font-family: HYQiHei-FZS;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  font-weight: 400;
  padding: 10px 0;
}

.blindBox-info {
  width: 91.2%;
  margin: 20px auto 10px;
  padding: 12px 0 14px;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
  .horizontal-awards-scroll {
    width: 77 * 4 px;
    margin: 0 auto;
    overflow: hidden;
    margin-top: 7px;
    ul {
      list-style: none;
      padding: 0;
      margin: 0 auto;
      &.ul-item {
        display: flex;
        .li-item {
          width: 67px;
          margin-right: 15px;
          text-align: center;
          img {
            width: 67px;
            height: 67px;
            margin-bottom: 7px;
          }
        }
      }
    }
  }
  .blindBox-info-reward {
    padding: 10px 10px 0px 0px;
    display: flex;
    overflow: auto;

    .blindBox-info-reward-box {
      width: 67px;
      margin-left: 15px;

      img {
        width: 15.733vw;
        height: 15.733vw;
        margin-bottom: 7px;
      }

      div {
        width: 67px;
        text-align: center;
      }
    }
  }

  .blindBox-info-reward-center {
    justify-content: center;
  }
}
.blindBox-prizes-title {
  color: #b27d13;
  div {
    &::before {
      background: linear-gradient(to right, transparent, #b27d13);
    }
    &::after {
      background: linear-gradient(to right, #b27d13, transparent);
    }
  }
}
.tiger-prizes-title {
  // color: #D7324C;
  div {
    &::before {
      background: linear-gradient(to right, transparent, #d7324c);
    }
    &::after {
      background: linear-gradient(to right, #d7324c, transparent);
    }
  }
}
.blindBox-info-title {
  width: 100%;
  height: 20px;
  font-family: HYQiHei-FZS;
  font-size: 16px;
  font-weight: 400;
  position: relative;

  div {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &::before {
      content: '';
      width: 40px;
      height: 3px;
      position: absolute;
      top: 50%;
      left: -60px;
    }

    &::after {
      content: '';
      width: 40px;
      height: 3px;
      position: absolute;
      top: 50%;
      right: -60px;
    }
  }
}
.tiger-btn {
  color: #ffffff;
  // background: #D7324C;
}
.blindBox-btn {
  background-image: linear-gradient(116deg, #fff8e9 0%, #f2ddb4 95%);
  color: #c79f60;
}
.blindBox-info-btn {
  font-family: HYQiHei-EZS;
  font-size: 14px;

  font-weight: 400;
  text-align: center;
  line-height: 28px;
  padding: 4px 12px;
  border-radius: 15px;
}

@keyframes blindBoxAnimation {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  60% {
    transform: scale(1.5);
    opacity: 0.4;
  }

  100% {
    transform: scale(0);
    opacity: 0;
  }
}
.share-btn-area {
  background-image: linear-gradient(90deg, #faf2df 0%, #f1e1c2 100%);
  border-radius: 100px 0 0 100px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  position: fixed;
  z-index: 10;
  top: calc(100vh - 237px);
  right: 0;
  padding: 5px 5px 5px 14px;
  max-width: 130px;
  line-height: 16px;
  box-sizing: border-box;
  .share-title {
    text-align: center;
    font-family: HYQiHei-GZS;
    font-size: 12px;
    color: #b27d13;
    font-weight: bold;
  }
  .share-desc {
    font-size: 11px;
    font-family: HYQiHei-EES;
    color: #b27d13;
    text-align: center;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.before-award-mask {
  width: 78%;
  height: 78%;
  top: 54%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 55px;
  position: absolute;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.4);
  .award-mask-center {
    width: 75%;
    font-size: 28px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    position: absolute;
    margin: 10px;
    top: 45%;
    left: 47%;
    transform: translate(-50%, -50%);

    .font-24 {
      margin-top: 10px;
      margin-bottom: 20px;
      font-size: 24px;
    }
    .font-20 {
      margin-top: 5px;
      margin-bottom: 5px;
      font-size: 20px;
    }
    .lottery-btn {
      width: 124px;
      height: 38px;
      background-image: linear-gradient(90deg, #faf2df 0%, #f1e1c2 100%);
      border-radius: 36px;
      position: relative;
      span {
        position: absolute;
        left: 50%; /* 定位父级的50% */
        top: 50%;
        transform: translate(-50%, -50%); /*自己的50% */
        font-family: HYQiHei-GEW;
        font-size: 18px;
        color: #b27d13;
        letter-spacing: 0;
        line-height: 54px;
        font-weight: 600;
      }
    }
  }
}
.guideLotteryUrl {
  width: 40%;
  height: 20%;
  position: absolute;
  top: 6%;
  left: 50%;
  transform: translate(-50%, 0);
}
.ellipsis-two {
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: inherit;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/awardRotate.vue